function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
import iamFormElement from 'scripts/classes/iamFormElement';
import { keepAutoDiscountCodes } from 'scripts/helpers/auto-discount';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import { cart } from 'scripts/helpers/iamota-shopify-ajax';
import { storefrontApi } from 'scripts/helpers/iamota-shopify-storefront';
import translate from 'scripts/helpers/iamota-translate';
import 'snippets/_containers/modal/modal';
import './_cart-delivery-options.scss';
var SHIPPING_METADATA_ENDPOINT_DEFAULT = 'https://sitka-seafood-market-vercel-functio.vercel.app/api/shipping-options';
var ADDRESS_VALIDATION_ENDPOINT_DEFAULT = 'https://sitka-seafood-market-vercel-functio.vercel.app/api/maps/address-validation';
var ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_MISSING = 'E.HOUSE_NUMBER.MISSING';
var ADDRESS_VALIDATION_ERROR_ZIP_NOT_FOUND = 'E.ZIP.NOT_FOUND';
var ADDRESS_VALIDATION_ERROR_ZIP_INVALID = 'E.ZIP.INVALID';
var ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_AND_ZIP_MISSING = 'E.HOUSE_NUMBER_AND_ZIP.MISSING';
var ADDRESS_VALIDATION_ERROR_UNIT_MISSING = 'E.UNIT.MISSING';
var ADDRESS_VALIDATION_ERROR_ADDRESS_NOT_FOUND = 'E.ADDRESS.NOT_FOUND';
var ADDRESS_VALIDATION_MODAL_STATE_HOUSE_NUMBER = 'house_number';
var ADDRESS_VALIDATION_MODAL_STATE_ZIP = 'zip';
var ADDRESS_VALIDATION_MODAL_STATE_UNIT = 'unit';
var ADDRESS_VALIDATION_MODAL_STATE_INFO = 'info';
var ADDRESS_VALIDATION_MODAL_STATE_SUGGESTED = 'suggested';
var ZIP_CODE_PATTERN = /^\d{5}(?:-\d{4})?$/;
var SHIPPING_TYPE_STANDARD = 'standard';
var SHIPPING_TYPE_EXPEDITED = 'expedited';
var SHIPPING_TYPE_BUNDLED = 'bundled';
var SYNTHETIC_BUNDLED_HANDLE = '__bundled__';
var SHIPPING_TYPE_DISPLAY_ORDER = {
  [SHIPPING_TYPE_STANDARD]: 0,
  [SHIPPING_TYPE_BUNDLED]: 1,
  [SHIPPING_TYPE_EXPEDITED]: 2
};
function normalizeMatchText() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
}
function isPostalCodeComponent() {
  var component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var normalizedComponent = normalizeMatchText(component);
  return normalizedComponent.includes('postal') || normalizedComponent.includes('zip');
}
function isStreetNumberComponent() {
  var component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var normalizedComponent = normalizeMatchText(component);
  return normalizedComponent.includes('street number') || normalizedComponent.includes('house number') || normalizedComponent.includes('premise') || normalizedComponent.includes('address line');
}
function isZipLikeToken() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /^\d{5}(?:-\d{4})?$/.test(String(token || '').trim());
}
function isUnitComponent() {
  var component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var normalizedComponent = normalizeMatchText(component);
  return normalizedComponent.includes('unit') || normalizedComponent.includes('apartment') || normalizedComponent.includes('suite') || normalizedComponent.includes('subpremise');
}
function normalizeAddressText() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
}
function readShippingTypeFromMatchText() {
  var normalizedText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!normalizedText) return '';
  if (normalizedText.includes('ship with next') || normalizedText.includes('next order') || normalizedText.includes('bundled') || normalizedText.includes('bundle')) {
    return SHIPPING_TYPE_BUNDLED;
  }
  if (normalizedText.includes('expedited') || normalizedText.includes('express') || normalizedText.includes('rush') || normalizedText.includes('priority')) {
    return SHIPPING_TYPE_EXPEDITED;
  }
  if (normalizedText.includes('standard')) {
    return SHIPPING_TYPE_STANDARD;
  }
  return '';
}
function getShippingTypeFromShopifyOption() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var normalizedCode = normalizeMatchText((option === null || option === void 0 ? void 0 : option.code) || '');
  var codeType = readShippingTypeFromMatchText(normalizedCode);
  if (codeType) return codeType;
  var normalizedTitle = normalizeMatchText((option === null || option === void 0 ? void 0 : option.title) || '');
  var titleType = readShippingTypeFromMatchText(normalizedTitle);
  if (titleType) return titleType;
  return readShippingTypeFromMatchText(normalizeMatchText((option === null || option === void 0 ? void 0 : option.handle) || ''));
}
function formatShippingDate(value) {
  if (!value) return '';
  var normalizedValue = String(value).trim();
  if (!normalizedValue) return '';

  // Parse YYYY-MM-DD as a local date to avoid timezone day-shift issues.
  var dateOnlyMatch = normalizedValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  var parsedDate = dateOnlyMatch ? new Date(Number(dateOnlyMatch[1]), Number(dateOnlyMatch[2]) - 1, Number(dateOnlyMatch[3])) : new Date(normalizedValue);
  if (Number.isNaN(parsedDate.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'short',
    day: 'numeric'
  }).format(parsedDate);
}
function readDateLabel() {
  var dateSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var formattedDate = formatShippingDate((dateSource === null || dateSource === void 0 ? void 0 : dateSource.estimatedDeliveryDate) || (dateSource === null || dateSource === void 0 ? void 0 : dateSource.shipDate) || '');
  if (formattedDate) return formattedDate;
  var displayDate = String((dateSource === null || dateSource === void 0 ? void 0 : dateSource.estimatedDeliveryDateDisplay) || (dateSource === null || dateSource === void 0 ? void 0 : dateSource.shipDateDisplay) || '').trim();
  return displayDate || '';
}
function normalizeEstimatedDeliveryDisplay() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value || '').trim().replace(/^Delivered as soon as\s+/i, '').trim();
}
function readEstimatedDeliveryDisplay() {
  var dateSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var formattedEstimatedDeliveryDate = formatShippingDate((dateSource === null || dateSource === void 0 ? void 0 : dateSource.estimatedDeliveryDate) || '');
  if (formattedEstimatedDeliveryDate) {
    return normalizeEstimatedDeliveryDisplay(formattedEstimatedDeliveryDate);
  }
  var displayValue = String((dateSource === null || dateSource === void 0 ? void 0 : dateSource.estimatedDeliveryDateDisplay) || (dateSource === null || dateSource === void 0 ? void 0 : dateSource.shipWeekDisplay) || (dateSource === null || dateSource === void 0 ? void 0 : dateSource.shipDateDisplay) || '').trim();
  if (displayValue) return normalizeEstimatedDeliveryDisplay(displayValue);
  return normalizeEstimatedDeliveryDisplay(readDateLabel(dateSource));
}
function readBundledDateLabel() {
  var dateSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var weekDisplay = String((dateSource === null || dateSource === void 0 ? void 0 : dateSource.shipWeekDisplay) || (dateSource === null || dateSource === void 0 ? void 0 : dateSource.estimatedDeliveryDateDisplay) || (dateSource === null || dateSource === void 0 ? void 0 : dateSource.shipDateDisplay) || '').trim();
  if (weekDisplay) return weekDisplay;
  return readDateLabel(dateSource);
}
function buildBaseShippingUiEntry() {
  var _ref, _clonedShopifyOption$, _clonedShopifyOption$2, _clonedShopifyOption$3;
  var shopifyOption = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var clonedShopifyOption = _objectSpread(_objectSpread({}, shopifyOption), {}, {
    estimatedCost: shopifyOption !== null && shopifyOption !== void 0 && shopifyOption.estimatedCost ? _objectSpread({}, shopifyOption.estimatedCost) : null
  });
  return {
    handle: String((clonedShopifyOption === null || clonedShopifyOption === void 0 ? void 0 : clonedShopifyOption.handle) || (clonedShopifyOption === null || clonedShopifyOption === void 0 ? void 0 : clonedShopifyOption.id) || '').trim(),
    title: String((clonedShopifyOption === null || clonedShopifyOption === void 0 ? void 0 : clonedShopifyOption.title) || '').trim(),
    code: String((clonedShopifyOption === null || clonedShopifyOption === void 0 ? void 0 : clonedShopifyOption.code) || '').trim(),
    type: getShippingTypeFromShopifyOption(clonedShopifyOption),
    displayTitle: String((clonedShopifyOption === null || clonedShopifyOption === void 0 ? void 0 : clonedShopifyOption.code) || (clonedShopifyOption === null || clonedShopifyOption === void 0 ? void 0 : clonedShopifyOption.title) || '').trim(),
    price: (_ref = (_clonedShopifyOption$ = clonedShopifyOption === null || clonedShopifyOption === void 0 ? void 0 : clonedShopifyOption.price) !== null && _clonedShopifyOption$ !== void 0 ? _clonedShopifyOption$ : clonedShopifyOption === null || clonedShopifyOption === void 0 || (_clonedShopifyOption$2 = clonedShopifyOption.estimatedCost) === null || _clonedShopifyOption$2 === void 0 ? void 0 : _clonedShopifyOption$2.amount) !== null && _ref !== void 0 ? _ref : null,
    currencyCode: (clonedShopifyOption === null || clonedShopifyOption === void 0 ? void 0 : clonedShopifyOption.currencyCode) || (clonedShopifyOption === null || clonedShopifyOption === void 0 || (_clonedShopifyOption$3 = clonedShopifyOption.estimatedCost) === null || _clonedShopifyOption$3 === void 0 ? void 0 : _clonedShopifyOption$3.currencyCode) || '',
    dateLabel: '',
    shipWeekPreference: '',
    estimatedDeliveryDateDisplay: '',
    standardSubOptions: [],
    source: clonedShopifyOption
  };
}
function buildBundledUiEntry(bundledDateEntry) {
  var _baseEntry$price;
  var baseEntry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var bundledDateLabel = readBundledDateLabel(bundledDateEntry);
  return {
    handle: String((baseEntry === null || baseEntry === void 0 ? void 0 : baseEntry.handle) || SYNTHETIC_BUNDLED_HANDLE).trim(),
    title: String((baseEntry === null || baseEntry === void 0 ? void 0 : baseEntry.title) || 'Ship with Next Order').trim(),
    code: String((baseEntry === null || baseEntry === void 0 ? void 0 : baseEntry.code) || '').trim(),
    type: SHIPPING_TYPE_BUNDLED,
    displayTitle: 'Ship with Next Order',
    price: (_baseEntry$price = baseEntry === null || baseEntry === void 0 ? void 0 : baseEntry.price) !== null && _baseEntry$price !== void 0 ? _baseEntry$price : null,
    currencyCode: (baseEntry === null || baseEntry === void 0 ? void 0 : baseEntry.currencyCode) || '',
    dateLabel: bundledDateLabel ? bundledDateLabel.startsWith('Delivered as soon as ') ? bundledDateLabel : "Delivered as soon as ".concat(bundledDateLabel) : '',
    shipWeekPreference: String((bundledDateEntry === null || bundledDateEntry === void 0 ? void 0 : bundledDateEntry.shipWeekPreference) || '').trim(),
    estimatedDeliveryDateDisplay: readEstimatedDeliveryDisplay(bundledDateEntry),
    standardSubOptions: [],
    source: baseEntry !== null && baseEntry !== void 0 && baseEntry.source ? _objectSpread({}, baseEntry.source) : {},
    isSynthetic: Boolean(baseEntry === null || baseEntry === void 0 ? void 0 : baseEntry.isSynthetic)
  };
}
function isDateOptionsShapeValid(dateOptions) {
  if (!dateOptions || typeof dateOptions !== 'object' || Array.isArray(dateOptions)) return false;
  var hasStandard = Array.isArray(dateOptions.standard);
  var hasBundled = Object.prototype.hasOwnProperty.call(dateOptions, 'bundled') && (dateOptions.bundled == null || typeof dateOptions.bundled === 'object');
  var hasExpedited = Object.prototype.hasOwnProperty.call(dateOptions, 'expedited') && (dateOptions.expedited == null || typeof dateOptions.expedited === 'object');
  return hasStandard || hasBundled || hasExpedited;
}
function readNumericPrice() {
  var entry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var value = Number(entry === null || entry === void 0 ? void 0 : entry.price);
  return Number.isFinite(value) ? value : Number.POSITIVE_INFINITY;
}
function sortShippingEntriesForDisplay() {
  var entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return [...entries].sort((leftEntry, rightEntry) => {
    var _SHIPPING_TYPE_DISPLA, _SHIPPING_TYPE_DISPLA2;
    var leftOrder = (_SHIPPING_TYPE_DISPLA = SHIPPING_TYPE_DISPLAY_ORDER[leftEntry === null || leftEntry === void 0 ? void 0 : leftEntry.type]) !== null && _SHIPPING_TYPE_DISPLA !== void 0 ? _SHIPPING_TYPE_DISPLA : Number.MAX_SAFE_INTEGER;
    var rightOrder = (_SHIPPING_TYPE_DISPLA2 = SHIPPING_TYPE_DISPLAY_ORDER[rightEntry === null || rightEntry === void 0 ? void 0 : rightEntry.type]) !== null && _SHIPPING_TYPE_DISPLA2 !== void 0 ? _SHIPPING_TYPE_DISPLA2 : Number.MAX_SAFE_INTEGER;
    return leftOrder - rightOrder;
  });
}
function findShippingEntryByType() {
  var entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var targetType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return entries.find(entry => String((entry === null || entry === void 0 ? void 0 : entry.type) || '').trim() === String(targetType || '').trim()) || null;
}
function inferMissingShippingTypes(entries, dateOptions) {
  var typedEntries = entries.map(entry => _objectSpread(_objectSpread({}, entry), {}, {
    source: _objectSpread({}, entry.source)
  }));
  var hasBundledData = Boolean((dateOptions === null || dateOptions === void 0 ? void 0 : dateOptions.bundled) && typeof dateOptions.bundled === 'object');
  var hasExpeditedData = Boolean((dateOptions === null || dateOptions === void 0 ? void 0 : dateOptions.expedited) && typeof dateOptions.expedited === 'object');
  var hasType = targetType => typedEntries.some(entry => entry.type === targetType);
  var unknownEntries = () => typedEntries.filter(entry => !entry.type);
  if (hasBundledData && !hasType(SHIPPING_TYPE_BUNDLED)) {
    var bundledHinted = unknownEntries().find(entry => {
      var _entry$source;
      var normalizedText = normalizeMatchText(((_entry$source = entry.source) === null || _entry$source === void 0 ? void 0 : _entry$source.title) || '');
      return normalizedText.includes('next') || normalizedText.includes('bundle');
    });
    if (bundledHinted) bundledHinted.type = SHIPPING_TYPE_BUNDLED;
  }
  if (hasExpeditedData && !hasType(SHIPPING_TYPE_EXPEDITED)) {
    var expeditedHinted = unknownEntries().find(entry => {
      var _entry$source2;
      var normalizedText = normalizeMatchText(((_entry$source2 = entry.source) === null || _entry$source2 === void 0 ? void 0 : _entry$source2.title) || '');
      return normalizedText.includes('fast') || normalizedText.includes('speed');
    });
    if (expeditedHinted) expeditedHinted.type = SHIPPING_TYPE_EXPEDITED;
  }

  // Deterministic fallback when Shopify labels are ambiguous:
  // lower price tends to be bundled, higher price tends to be expedited.
  if (hasBundledData && hasExpeditedData && (!hasType(SHIPPING_TYPE_BUNDLED) || !hasType(SHIPPING_TYPE_EXPEDITED))) {
    var remainingUnknown = unknownEntries().sort((a, b) => readNumericPrice(a) - readNumericPrice(b));
    if (!hasType(SHIPPING_TYPE_BUNDLED) && remainingUnknown.length > 0) {
      remainingUnknown[0].type = SHIPPING_TYPE_BUNDLED;
    }
    if (!hasType(SHIPPING_TYPE_EXPEDITED) && remainingUnknown.length > 1) {
      remainingUnknown[remainingUnknown.length - 1].type = SHIPPING_TYPE_EXPEDITED;
    }
  }

  // If endpoint only returns bundled+expedited dates, map those two Shopify rows predictably.
  // This keeps Shopify handles/prices intact while ensuring each returned date is attached to one row.
  var hasStandardDates = Array.isArray(dateOptions === null || dateOptions === void 0 ? void 0 : dateOptions.standard) && dateOptions.standard.length > 0;
  if (!hasStandardDates && hasBundledData && hasExpeditedData && typedEntries.length === 2) {
    var sortedEntries = [...typedEntries].sort((a, b) => readNumericPrice(a) - readNumericPrice(b));
    if (sortedEntries[0]) sortedEntries[0].type = SHIPPING_TYPE_BUNDLED;
    if (sortedEntries[1]) sortedEntries[1].type = SHIPPING_TYPE_EXPEDITED;
  }
  return typedEntries;
}
export function mergeShippingOptions(shopifyOptions, dateOptions) {
  var _orderedMergedEntries, _orderedMergedEntries2;
  var safeShopifyOptions = Array.isArray(shopifyOptions) ? shopifyOptions : [];
  var fallbackEntries = sortShippingEntriesForDisplay(safeShopifyOptions.map(shopifyOption => buildBaseShippingUiEntry(shopifyOption)));

  // Fallback rule: without valid date options, keep Shopify-only rendering unchanged.
  if (!isDateOptionsShapeValid(dateOptions)) {
    var _fallbackEntries$find, _fallbackEntries$;
    var fallbackDefault = ((_fallbackEntries$find = fallbackEntries.find(entry => entry.type === SHIPPING_TYPE_STANDARD)) === null || _fallbackEntries$find === void 0 ? void 0 : _fallbackEntries$find.handle) || ((_fallbackEntries$ = fallbackEntries[0]) === null || _fallbackEntries$ === void 0 ? void 0 : _fallbackEntries$.handle) || '';
    return {
      entries: fallbackEntries,
      isFallback: true,
      defaultHandle: fallbackDefault
    };
  }
  var standardDateEntries = Array.isArray(dateOptions === null || dateOptions === void 0 ? void 0 : dateOptions.standard) ? dateOptions.standard : [];
  var bundledDateEntry = dateOptions !== null && dateOptions !== void 0 && dateOptions.bundled && typeof dateOptions.bundled === 'object' ? dateOptions.bundled : null;
  var expeditedDateEntry = dateOptions !== null && dateOptions !== void 0 && dateOptions.expedited && typeof dateOptions.expedited === 'object' ? dateOptions.expedited : null;
  var typedEntries = inferMissingShippingTypes(fallbackEntries, dateOptions);
  var mergedEntries = typedEntries.map(entry => {
    var nextEntry = _objectSpread(_objectSpread({}, entry), {}, {
      source: _objectSpread({}, entry.source)
    });
    if (nextEntry.type === SHIPPING_TYPE_STANDARD) {
      nextEntry.displayTitle = 'Standard Shipping';
      nextEntry.standardSubOptions = standardDateEntries.map((standardOption, index) => {
        if (!standardOption || typeof standardOption !== 'object') return null;
        var formattedDate = readDateLabel(standardOption);
        if (!formattedDate) return null;
        var value = String(standardOption.shipWeekPreference || "standard-".concat(index + 1)).trim();
        return {
          value,
          shipWeekPreference: standardOption.shipWeekPreference,
          estimatedDeliveryDate: standardOption.estimatedDeliveryDate,
          estimatedDeliveryDateDisplay: readEstimatedDeliveryDisplay(standardOption),
          shipDate: standardOption.shipDate,
          label: formattedDate.startsWith('Delivered as soon as ') ? formattedDate : "Delivered as soon as ".concat(formattedDate)
        };
      }).filter(Boolean);
    }
    if (nextEntry.type === SHIPPING_TYPE_BUNDLED) {
      if (!bundledDateEntry) return null;
      return buildBundledUiEntry(bundledDateEntry, nextEntry);
    }
    if (nextEntry.type === SHIPPING_TYPE_EXPEDITED) {
      // Never invent options: hide expedited unless both Shopify mapping and expedited date data exist.
      if (!expeditedDateEntry) return null;
      var expeditedDateLabel = readDateLabel(expeditedDateEntry);
      nextEntry.estimatedDeliveryDateDisplay = readEstimatedDeliveryDisplay(expeditedDateEntry);
      if (expeditedDateLabel) {
        nextEntry.dateLabel = expeditedDateLabel.startsWith('Delivered as soon as ') ? expeditedDateLabel : "Delivered as soon as ".concat(expeditedDateLabel);
      }
    }
    return nextEntry;
  }).filter(Boolean);
  if (bundledDateEntry && !mergedEntries.some(entry => (entry === null || entry === void 0 ? void 0 : entry.type) === SHIPPING_TYPE_BUNDLED)) {
    var standardEntryForBundled = findShippingEntryByType(mergedEntries, SHIPPING_TYPE_STANDARD) || findShippingEntryByType(typedEntries, SHIPPING_TYPE_STANDARD) || findShippingEntryByType(fallbackEntries, SHIPPING_TYPE_STANDARD) || null;
    mergedEntries.push(buildBundledUiEntry(bundledDateEntry, _objectSpread(_objectSpread({}, standardEntryForBundled || {}), {}, {
      handle: SYNTHETIC_BUNDLED_HANDLE,
      title: 'Ship with Next Order',
      code: '',
      isSynthetic: true
    })));
  }
  var orderedMergedEntries = sortShippingEntriesForDisplay(mergedEntries);
  var defaultHandle = ((_orderedMergedEntries = orderedMergedEntries.find(entry => entry.type === SHIPPING_TYPE_STANDARD)) === null || _orderedMergedEntries === void 0 ? void 0 : _orderedMergedEntries.handle) || ((_orderedMergedEntries2 = orderedMergedEntries[0]) === null || _orderedMergedEntries2 === void 0 ? void 0 : _orderedMergedEntries2.handle) || '';
  if (orderedMergedEntries.length === 0) {
    var _fallbackEntries$find2, _fallbackEntries$2;
    return {
      entries: fallbackEntries,
      isFallback: true,
      defaultHandle: ((_fallbackEntries$find2 = fallbackEntries.find(entry => entry.type === SHIPPING_TYPE_STANDARD)) === null || _fallbackEntries$find2 === void 0 ? void 0 : _fallbackEntries$find2.handle) || ((_fallbackEntries$2 = fallbackEntries[0]) === null || _fallbackEntries$2 === void 0 ? void 0 : _fallbackEntries$2.handle) || ''
    };
  }
  return {
    // Shopify remains authoritative for selectable handles and prices; this model is UI decoration only.
    entries: orderedMergedEntries,
    isFallback: false,
    defaultHandle
  };
}
var CART_DELIVERY_ADDRESS_FIELDS = "\n    address1\n    address2\n    city\n    province\n    provinceCode\n    zip\n    country\n    countryCodeV2\n";
var CART_DELIVERY_GROUP_FIELDS = "\n    id\n    deliveryAddress {\n        ... on MailingAddress {\n            ".concat(CART_DELIVERY_ADDRESS_FIELDS, "\n        }\n    }\n    selectedDeliveryOption {\n        handle\n    }\n    deliveryOptions {\n        code\n        handle\n        title\n        estimatedCost {\n            amount\n            currencyCode\n        }\n    }\n");
var CART_DELIVERY_SELECTION_FIELDS = "\n    id\n    attributes {\n        key\n        value\n    }\n    deliveryGroups(first: 10) {\n        nodes {\n            ".concat(CART_DELIVERY_GROUP_FIELDS, "\n        }\n    }\n");
var MUTATION_FEEDBACK_FIELDS = "\n    userErrors {\n        field\n        message\n    }\n    warnings {\n        code\n        message\n        target\n    }\n";
var CART_DELIVERY_OPTIONS_QUERY = "\n    query CartDeliveryOptions($id: ID!) {\n        cart(id: $id) {\n            ".concat(CART_DELIVERY_SELECTION_FIELDS, "\n        }\n    }\n");
var CART_SELECTED_DELIVERY_OPTIONS_UPDATE_MUTATION = "\n    mutation CartSelectedDeliveryOptionsUpdate($cartId: ID!, $selectedDeliveryOptions: [CartSelectedDeliveryOptionInput!]!) {\n        cartSelectedDeliveryOptionsUpdate(\n            cartId: $cartId\n            selectedDeliveryOptions: $selectedDeliveryOptions\n        ) {\n            cart {\n               ".concat(CART_DELIVERY_SELECTION_FIELDS, "\n            }\n            ").concat(MUTATION_FEEDBACK_FIELDS, "\n        }\n    }\n");
var CART_DELIVERY_ADDRESSES_ADD_MUTATION = "\n    mutation CartDeliveryAddressesAdd($cartId: ID!, $addresses: [CartSelectableAddressInput!]!) {\n        cartDeliveryAddressesAdd(\n            cartId: $cartId\n            addresses: $addresses\n        ) {\n            cart {\n               ".concat(CART_DELIVERY_SELECTION_FIELDS, "\n            }\n            ").concat(MUTATION_FEEDBACK_FIELDS, "\n        }\n    }\n");
var UPDATE_CHECKOUT_CUSTOM_ATTRIBUTES_MUTATION = "\n    mutation UpdateCheckoutCustomAttributes($cartId: ID!, $attributes: [AttributeInput!]!) {\n        cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {\n            cart {\n                id\n                attributes {\n                    key\n                    value\n                }\n            }\n            userErrors {\n                code\n                field\n                message\n            }\n        }\n    }\n";
var UPDATE_DISCOUNT_CODES_MUTATION = "\n    mutation UpdateDiscountCodes($cartId: ID!, $discountCodes: [String!]) {\n        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {\n            cart {\n                id\n            }\n            userErrors {\n                field\n                message\n            }\n            warnings {\n                code\n                message\n                target\n            }\n        }\n    }\n";
class iamCartDeliveryOptions extends iamFormElement {
  get namespace() {
    return "".concat(this.formName, ":deliveryOptions");
  }
  onFormInit() {
    var _this$iamForm;
    this.stateContainer = this.querySelector('[data-delivery-options-state]');
    this.optionsContainer = this.querySelector('[data-delivery-options-list]');
    this.addressInput = this.querySelector('[data-address-autocomplete-input]');
    this.addressValidationFeedback = this.querySelector('[data-address-validation-feedback]');
    this.addressValidationModalComponent = this.querySelector('[data-address-validation-modal]');
    this.addressValidationModalTitle = this.querySelector('[data-address-validation-title]');
    this.addressValidationModalBody = this.querySelector('[data-address-validation-body]');
    this.addressValidationModalForm = this.querySelector('[data-address-validation-form]');
    this.addressValidationModalInputLabel = this.querySelector('[data-address-validation-input-label]');
    this.addressValidationModalInput = this.querySelector('[data-address-validation-input]');
    this.addressValidationModalInputError = this.querySelector('[data-address-validation-input-error]');
    this.addressValidationModalInputSecondaryLabel = this.querySelector('[data-address-validation-input-secondary-label]');
    this.addressValidationModalInputSecondary = this.querySelector('[data-address-validation-input-secondary]');
    this.addressValidationModalInputSecondaryError = this.querySelector('[data-address-validation-input-secondary-error]');
    this.addressValidationModalSuggestedCard = this.querySelector('[data-address-validation-suggested-card]');
    this.addressValidationModalSuggestedValue = this.querySelector('[data-address-validation-suggested-value]');
    this.addressValidationModalSubmit = this.querySelector('[data-address-validation-submit]');
    this.addressValidationModalCancelButtons = this.querySelectorAll('[data-address-validation-cancel]');
    this.shippingMetadataEndpoint = this.dataset.shippingMetadataEndpoint || SHIPPING_METADATA_ENDPOINT_DEFAULT;
    this.customerEmail = String(this.dataset.customerEmail || '').trim();
    this.deliveryOptionInputName = 'cart-delivery-option';
    this.cartToken = null;
    this.cartId = null;
    this.deliveryGroupId = null;
    this.selectedHandle = '';
    this.pendingSelectedHandle = '';
    this.deliveryOptions = [];
    this.latestCartPayload = ((_this$iamForm = this.iamForm) === null || _this$iamForm === void 0 ? void 0 : _this$iamForm.cart) || null;
    this.shippingMetadataAbortController = null;
    this.shippingMetadataRequestId = 0;
    this.initialDateOptions = this.readDateOptionsInput(this.dataset.dateOptionsJson || this.dataset.dateOptions || this.dataset.shippingDateOptionsJson || this.dataset.shippingDateOptions);
    this.dateOptions = this.initialDateOptions;
    this.mergedShippingModel = {
      entries: [],
      isFallback: true,
      defaultHandle: ''
    };
    this.selectedShipWeekPreferenceByHandle = {};
    this.selectedAddress = null;
    this.isAssociatingAddress = false;
    this.pendingDeliveryAddress = null;
    this.nextOrderScheduledAt = undefined;
    this.nextOrderScheduledAtRequest = null;
    this.addressValidationRequestId = 0;
    this.addressValidationModalState = '';
    this.addressValidationIssue = '';
    this.addressValidationInputValue = '';
    this.addressValidationSuggestedAddressCandidate = null;
    this.lastAssociatedAddress = null;
    this.boundOnAddressSelected = this.onAddressSelected.bind(this);
    this.boundOnAddressValidationModalSubmitClick = this.onAddressValidationModalSubmitClick.bind(this);
    this.boundOnAddressValidationModalInputKeydown = this.onAddressValidationModalInputKeydown.bind(this);
    this.boundOnAddressValidationModalCancel = this.onAddressValidationModalCancel.bind(this);
    if (!this.validateRequiredAttributes(['stateContainer', 'optionsContainer'])) return;
    this.addEventListener('sitka:address:selected', this.boundOnAddressSelected);
    if (this.addressValidationModalSubmit) {
      this.addressValidationModalSubmit.addEventListener('click', this.boundOnAddressValidationModalSubmitClick);
    }
    if (this.addressValidationModalInput) {
      this.addressValidationModalInput.addEventListener('keydown', this.boundOnAddressValidationModalInputKeydown);
    }
    if (this.addressValidationModalInputSecondary) {
      this.addressValidationModalInputSecondary.addEventListener('keydown', this.boundOnAddressValidationModalInputKeydown);
    }
    this.addressValidationModalCancelButtons.forEach(cancelButton => {
      cancelButton.addEventListener('click', this.boundOnAddressValidationModalCancel);
    });
    this.optionsContainer.addEventListener('change', this.onDeliveryOptionChange.bind(this));
    iamotaEventHandler.subscribe('cart:modified', this.onCartModified.bind(this), {
      source: 'cart-delivery-options'
    });
    this.loadDeliveryOptions();
  }
  disconnectedCallback() {
    var _this$_sitkaAddressAu;
    super.disconnectedCallback();
    if (this.boundOnAddressSelected) {
      this.removeEventListener('sitka:address:selected', this.boundOnAddressSelected);
    }
    if (this.addressValidationModalSubmit && this.boundOnAddressValidationModalSubmitClick) {
      this.addressValidationModalSubmit.removeEventListener('click', this.boundOnAddressValidationModalSubmitClick);
    }
    if (this.addressValidationModalInput && this.boundOnAddressValidationModalInputKeydown) {
      this.addressValidationModalInput.removeEventListener('keydown', this.boundOnAddressValidationModalInputKeydown);
    }
    if (this.addressValidationModalInputSecondary && this.boundOnAddressValidationModalInputKeydown) {
      this.addressValidationModalInputSecondary.removeEventListener('keydown', this.boundOnAddressValidationModalInputKeydown);
    }
    if (this.boundOnAddressValidationModalCancel) {
      this.addressValidationModalCancelButtons.forEach(cancelButton => {
        cancelButton.removeEventListener('click', this.boundOnAddressValidationModalCancel);
      });
    }
    if ((_this$_sitkaAddressAu = this._sitkaAddressAutocompleteInstance) !== null && _this$_sitkaAddressAu !== void 0 && _this$_sitkaAddressAu.destroy) {
      this._sitkaAddressAutocompleteInstance.destroy();
    }
    if (this.shippingMetadataAbortController) {
      this.shippingMetadataAbortController.abort();
      this.shippingMetadataAbortController = null;
    }
  }
  onCartModified(cartPayload) {
    var normalizedCart = this.extractCartPayload(cartPayload);
    if (normalizedCart) {
      this.latestCartPayload = normalizedCart;
      var nextDateOptions = this.readDateOptionsInput((normalizedCart === null || normalizedCart === void 0 ? void 0 : normalizedCart.dateOptions) || (normalizedCart === null || normalizedCart === void 0 ? void 0 : normalizedCart.date_options) || (normalizedCart === null || normalizedCart === void 0 ? void 0 : normalizedCart.shippingDateOptions) || (normalizedCart === null || normalizedCart === void 0 ? void 0 : normalizedCart.shipping_date_options));
      if (nextDateOptions) {
        this.dateOptions = nextDateOptions;
      }
    }
    this.cartToken = this.resolveCartToken(cartPayload);
    this.loadDeliveryOptions({
      showLoading: false
    });
  }
  ensureCartToken() {
    var _this = this;
    return _asyncToGenerator(function* () {
      var existingToken = _this.resolveCartToken();
      if (_this.hasSecretKey(existingToken)) return existingToken;
      try {
        var _this$iamForm2;
        var latestCart = yield cart.fetch();
        var fetchedToken = (latestCart === null || latestCart === void 0 ? void 0 : latestCart.token) || null;
        if (fetchedToken && (_this$iamForm2 = _this.iamForm) !== null && _this$iamForm2 !== void 0 && _this$iamForm2.cart) {
          _this.iamForm.cart.token = fetchedToken;
        }
        if (_this.hasSecretKey(fetchedToken)) return fetchedToken;
        return fetchedToken || existingToken;
      } catch (error) {
        console.error('cartForm: Error fetching cart token for delivery options:', error);
        return existingToken || null;
      }
    })();
  }
  resolveCartToken() {
    var _cartPayload$cart, _this$iamForm3;
    var cartPayload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var payloadToken = (cartPayload === null || cartPayload === void 0 ? void 0 : cartPayload.token) || (cartPayload === null || cartPayload === void 0 || (_cartPayload$cart = cartPayload.cart) === null || _cartPayload$cart === void 0 ? void 0 : _cartPayload$cart.token);
    if (typeof payloadToken === 'string' && payloadToken.length > 0) return payloadToken.trim();
    var formToken = (_this$iamForm3 = this.iamForm) === null || _this$iamForm3 === void 0 || (_this$iamForm3 = _this$iamForm3.cart) === null || _this$iamForm3 === void 0 ? void 0 : _this$iamForm3.token;
    if (typeof formToken === 'string' && formToken.length > 0) return formToken.trim();
    return this.cartToken || null;
  }
  hasSecretKey(cartToken) {
    return typeof cartToken === 'string' && cartToken.includes('?key=');
  }
  buildCartId(cartToken) {
    if (cartToken !== null && cartToken !== void 0 && cartToken.startsWith('gid://shopify/Cart/')) return cartToken;
    return "gid://shopify/Cart/".concat(cartToken);
  }
  setMessage() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    this.stateContainer.textContent = message;
  }
  setAddressValidationFeedback() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (!this.addressValidationFeedback) return;
    this.addressValidationFeedback.textContent = message;
  }
  setAddressValidationModalInputError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (!this.addressValidationModalInputError) return;
    this.addressValidationModalInputError.textContent = message;
  }
  setAddressValidationModalSecondaryInputError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (!this.addressValidationModalInputSecondaryError) return;
    this.addressValidationModalInputSecondaryError.textContent = message;
  }
  setAddressValidationModalSubmitting(isSubmitting) {
    var defaultLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (!this.addressValidationModalSubmit) return;
    this.addressValidationModalSubmit.disabled = Boolean(isSubmitting);
    this.addressValidationModalCancelButtons.forEach(cancelButton => {
      cancelButton.disabled = Boolean(isSubmitting);
    });
    if (isSubmitting) {
      this.addressValidationModalSubmit.textContent = translate('Validating...', 'cartDeliveryOptions.address_validation.modal.validating');
    } else if (defaultLabel) {
      this.addressValidationModalSubmit.textContent = defaultLabel;
    }
  }
  closeAddressValidationModal() {
    var _this$addressValidati;
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$focusInput = _ref2.focusInput,
      focusInput = _ref2$focusInput === void 0 ? false : _ref2$focusInput;
    if ((_this$addressValidati = this.addressValidationModalComponent) !== null && _this$addressValidati !== void 0 && _this$addressValidati.classList.contains('modal--open') && typeof this.addressValidationModalComponent.closeModal === 'function') {
      this.addressValidationModalComponent.closeModal();
    }
    this.addressValidationModalState = '';
    this.addressValidationIssue = '';
    this.addressValidationInputValue = '';
    this.addressValidationSuggestedAddressCandidate = null;
    this.setAddressValidationModalInputError('');
    this.setAddressValidationModalSecondaryInputError('');
    if (this.addressValidationModalSuggestedValue) {
      this.addressValidationModalSuggestedValue.textContent = '';
    }
    if (focusInput && this.addressInput) {
      this.addressInput.focus();
    }
  }
  buildAddressFromSuggestedPostalAddress() {
    var currentAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var suggestedPostalAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var formattedAddress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var suggestedLines = Array.isArray(suggestedPostalAddress === null || suggestedPostalAddress === void 0 ? void 0 : suggestedPostalAddress.addressLines) ? suggestedPostalAddress.addressLines.filter(Boolean) : [];
    return _objectSpread(_objectSpread({}, currentAddress), {}, {
      address1: String(suggestedLines[0] || currentAddress.address1 || '').trim(),
      address2: String(suggestedLines.slice(1).join(', ') || currentAddress.address2 || '').trim(),
      city: String((suggestedPostalAddress === null || suggestedPostalAddress === void 0 ? void 0 : suggestedPostalAddress.locality) || currentAddress.city || '').trim(),
      provinceCode: String((suggestedPostalAddress === null || suggestedPostalAddress === void 0 ? void 0 : suggestedPostalAddress.administrativeArea) || currentAddress.provinceCode || '').trim(),
      province: String((suggestedPostalAddress === null || suggestedPostalAddress === void 0 ? void 0 : suggestedPostalAddress.administrativeArea) || currentAddress.province || '').trim(),
      zip: String((suggestedPostalAddress === null || suggestedPostalAddress === void 0 ? void 0 : suggestedPostalAddress.postalCode) || currentAddress.zip || '').trim(),
      country: String((suggestedPostalAddress === null || suggestedPostalAddress === void 0 ? void 0 : suggestedPostalAddress.regionCode) || currentAddress.country || 'US').trim() || 'US',
      formattedAddress: String(formattedAddress || currentAddress.formattedAddress || '').trim()
    });
  }
  hasMeaningfulSuggestedAddressChange() {
    var currentAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var suggestedAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var currentProvince = normalizeAddressText((currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.provinceCode) || (currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.province) || '');
    var suggestedProvince = normalizeAddressText((suggestedAddress === null || suggestedAddress === void 0 ? void 0 : suggestedAddress.provinceCode) || (suggestedAddress === null || suggestedAddress === void 0 ? void 0 : suggestedAddress.province) || '');
    return normalizeAddressText((currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.address1) || '') !== normalizeAddressText((suggestedAddress === null || suggestedAddress === void 0 ? void 0 : suggestedAddress.address1) || '') || normalizeAddressText((currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.city) || '') !== normalizeAddressText((suggestedAddress === null || suggestedAddress === void 0 ? void 0 : suggestedAddress.city) || '') || currentProvince !== suggestedProvince || normalizeAddressText((currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.zip) || '') !== normalizeAddressText((suggestedAddress === null || suggestedAddress === void 0 ? void 0 : suggestedAddress.zip) || '') || normalizeAddressText((currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.country) || '') !== normalizeAddressText((suggestedAddress === null || suggestedAddress === void 0 ? void 0 : suggestedAddress.country) || '');
  }
  getAddressChoiceLabel() {
    var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return [String(address.address1 || '').trim(), String(address.city || '').trim(), String(address.provinceCode || address.province || '').trim(), String(address.zip || '').trim()].filter(Boolean).join(', ');
  }
  getAddressValidationModalConfig() {
    var errorCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (errorCode === ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_AND_ZIP_MISSING) {
      var _this$selectedAddress;
      return {
        state: ADDRESS_VALIDATION_MODAL_STATE_HOUSE_NUMBER,
        requiresInput: true,
        showSuggestedCard: false,
        title: translate('Complete your address', 'cartDeliveryOptions.address_validation.modal.house_zip_title'),
        body: translate('We need both your street number and ZIP code to validate this address.', 'cartDeliveryOptions.address_validation.modal.house_zip_body'),
        inputLabel: translate('Street number', 'cartDeliveryOptions.address_validation.modal.house_number_label'),
        inputPlaceholder: translate('e.g. 123', 'cartDeliveryOptions.address_validation.modal.house_number_placeholder'),
        secondaryInputLabel: translate('ZIP code', 'cartDeliveryOptions.address_validation.modal.zip_label'),
        secondaryInputPlaceholder: translate('e.g. 98101', 'cartDeliveryOptions.address_validation.modal.zip_placeholder'),
        secondaryInputMode: 'numeric',
        secondaryPattern: ZIP_CODE_PATTERN.source,
        submitLabel: translate('Validate address', 'cartDeliveryOptions.address_validation.modal.submit'),
        inputMode: 'text',
        pattern: '',
        value: String(this.addressValidationInputValue || '').trim(),
        secondaryValue: String(((_this$selectedAddress = this.selectedAddress) === null || _this$selectedAddress === void 0 ? void 0 : _this$selectedAddress.zip) || '').trim()
      };
    }
    if (errorCode === ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_MISSING) {
      return {
        state: ADDRESS_VALIDATION_MODAL_STATE_HOUSE_NUMBER,
        requiresInput: true,
        title: translate('Add your street number', 'cartDeliveryOptions.address_validation.modal.house_number_title'),
        body: translate('We could not validate this address because the street number is missing.', 'cartDeliveryOptions.address_validation.modal.house_number_body'),
        inputLabel: translate('Street number', 'cartDeliveryOptions.address_validation.modal.house_number_label'),
        inputPlaceholder: translate('e.g. 123', 'cartDeliveryOptions.address_validation.modal.house_number_placeholder'),
        submitLabel: translate('Validate address', 'cartDeliveryOptions.address_validation.modal.submit'),
        inputMode: 'text',
        pattern: '',
        value: String(this.addressValidationInputValue || '').trim(),
        secondaryInputLabel: '',
        secondaryInputPlaceholder: '',
        secondaryInputMode: 'text',
        secondaryPattern: '',
        secondaryValue: ''
      };
    }
    if (errorCode === ADDRESS_VALIDATION_ERROR_UNIT_MISSING) {
      var _this$selectedAddress2;
      return {
        state: ADDRESS_VALIDATION_MODAL_STATE_UNIT,
        requiresInput: true,
        title: translate('Add your apartment or suite', 'cartDeliveryOptions.address_validation.modal.unit_title'),
        body: translate('This address needs a unit number (apartment, suite, etc.) for delivery validation.', 'cartDeliveryOptions.address_validation.modal.unit_body'),
        inputLabel: translate('Apartment or suite', 'cartDeliveryOptions.address_validation.modal.unit_label'),
        inputPlaceholder: translate('e.g. Apt 5B', 'cartDeliveryOptions.address_validation.modal.unit_placeholder'),
        submitLabel: translate('Validate address', 'cartDeliveryOptions.address_validation.modal.submit'),
        inputMode: 'text',
        pattern: '',
        value: String(this.addressValidationInputValue || ((_this$selectedAddress2 = this.selectedAddress) === null || _this$selectedAddress2 === void 0 ? void 0 : _this$selectedAddress2.address2) || '').trim(),
        secondaryInputLabel: '',
        secondaryInputPlaceholder: '',
        secondaryInputMode: 'text',
        secondaryPattern: '',
        secondaryValue: ''
      };
    }
    if (errorCode === ADDRESS_VALIDATION_ERROR_ZIP_NOT_FOUND || errorCode === ADDRESS_VALIDATION_ERROR_ZIP_INVALID) {
      var _this$selectedAddress3;
      return {
        state: ADDRESS_VALIDATION_MODAL_STATE_ZIP,
        requiresInput: true,
        title: translate('Add your ZIP code', 'cartDeliveryOptions.address_validation.modal.zip_title'),
        body: errorCode === ADDRESS_VALIDATION_ERROR_ZIP_INVALID ? translate('We could not confirm this ZIP code. Enter a valid ZIP code to continue validation.', 'cartDeliveryOptions.address_validation.modal.zip_invalid_body') : translate('We could not validate this address because the ZIP code is missing.', 'cartDeliveryOptions.address_validation.modal.zip_missing_body'),
        inputLabel: translate('ZIP code', 'cartDeliveryOptions.address_validation.modal.zip_label'),
        inputPlaceholder: translate('e.g. 98101', 'cartDeliveryOptions.address_validation.modal.zip_placeholder'),
        submitLabel: translate('Validate address', 'cartDeliveryOptions.address_validation.modal.submit'),
        inputMode: 'numeric',
        pattern: ZIP_CODE_PATTERN.source,
        value: String(this.addressValidationInputValue || ((_this$selectedAddress3 = this.selectedAddress) === null || _this$selectedAddress3 === void 0 ? void 0 : _this$selectedAddress3.zip) || '').trim(),
        secondaryInputLabel: '',
        secondaryInputPlaceholder: '',
        secondaryInputMode: 'text',
        secondaryPattern: '',
        secondaryValue: ''
      };
    }
    return {
      state: ADDRESS_VALIDATION_MODAL_STATE_INFO,
      requiresInput: false,
      title: translate('Address not found', 'cartDeliveryOptions.address_validation.modal.address_not_found_title'),
      body: translate('This address could not be validated for delivery. Please search for a different address.', 'cartDeliveryOptions.address_validation.modal.address_not_found_body'),
      inputLabel: '',
      inputPlaceholder: '',
      submitLabel: translate('Continue', 'cartDeliveryOptions.address_validation.modal.continue'),
      inputMode: 'text',
      pattern: '',
      value: '',
      secondaryInputLabel: '',
      secondaryInputPlaceholder: '',
      secondaryInputMode: 'text',
      secondaryPattern: '',
      secondaryValue: ''
    };
  }
  renderAddressValidationModal(config) {
    if (!this.addressValidationModalComponent || !config) return;
    if (this.addressValidationModalTitle) {
      this.addressValidationModalTitle.textContent = config.title || '';
    }
    if (this.addressValidationModalBody) {
      this.addressValidationModalBody.textContent = config.body || '';
    }
    var shouldRenderInput = Boolean(config.requiresInput);
    var shouldRenderSuggestedCard = Boolean(config.showSuggestedCard);
    if (this.addressValidationModalSubmit) {
      this.addressValidationModalSubmit.textContent = config.submitLabel || '';
    }
    if (this.addressValidationModalInputLabel) {
      this.addressValidationModalInputLabel.textContent = config.inputLabel || '';
    }
    if (this.addressValidationModalInputLabel) {
      this.addressValidationModalInputLabel.hidden = !shouldRenderInput;
      this.addressValidationModalInputLabel.style.display = shouldRenderInput ? '' : 'none';
    }
    if (this.addressValidationModalInput) {
      this.addressValidationModalInput.value = String(config.value || '').trim();
      this.addressValidationModalInput.placeholder = config.inputPlaceholder || '';
      this.addressValidationModalInput.inputMode = config.inputMode || 'text';
      this.addressValidationModalInput.required = shouldRenderInput;
      this.addressValidationModalInput.hidden = !shouldRenderInput;
      this.addressValidationModalInput.style.display = shouldRenderInput ? '' : 'none';
      if (config.pattern) {
        this.addressValidationModalInput.setAttribute('pattern', config.pattern);
      } else {
        this.addressValidationModalInput.removeAttribute('pattern');
      }
    }
    if (this.addressValidationModalInputError) {
      this.addressValidationModalInputError.hidden = !shouldRenderInput;
      this.addressValidationModalInputError.style.display = shouldRenderInput ? '' : 'none';
    }
    var shouldRenderSecondaryInput = Boolean(config.secondaryInputLabel);
    if (this.addressValidationModalInputSecondaryLabel) {
      this.addressValidationModalInputSecondaryLabel.textContent = config.secondaryInputLabel || '';
      this.addressValidationModalInputSecondaryLabel.hidden = !shouldRenderSecondaryInput;
      this.addressValidationModalInputSecondaryLabel.style.display = shouldRenderSecondaryInput ? '' : 'none';
    }
    if (this.addressValidationModalInputSecondary) {
      this.addressValidationModalInputSecondary.value = String(config.secondaryValue || '').trim();
      this.addressValidationModalInputSecondary.placeholder = config.secondaryInputPlaceholder || '';
      this.addressValidationModalInputSecondary.inputMode = config.secondaryInputMode || 'text';
      this.addressValidationModalInputSecondary.required = shouldRenderSecondaryInput;
      this.addressValidationModalInputSecondary.hidden = !shouldRenderSecondaryInput;
      this.addressValidationModalInputSecondary.style.display = shouldRenderSecondaryInput ? '' : 'none';
      if (config.secondaryPattern) {
        this.addressValidationModalInputSecondary.setAttribute('pattern', config.secondaryPattern);
      } else {
        this.addressValidationModalInputSecondary.removeAttribute('pattern');
      }
    }
    if (this.addressValidationModalInputSecondaryError) {
      this.addressValidationModalInputSecondaryError.hidden = !shouldRenderSecondaryInput;
      this.addressValidationModalInputSecondaryError.style.display = shouldRenderSecondaryInput ? '' : 'none';
    }
    if (this.addressValidationModalSuggestedCard) {
      this.addressValidationModalSuggestedCard.hidden = !shouldRenderSuggestedCard;
      this.addressValidationModalSuggestedCard.style.display = shouldRenderSuggestedCard ? '' : 'none';
    }
    if (this.addressValidationModalSuggestedValue) {
      this.addressValidationModalSuggestedValue.textContent = config.suggestedAddressLabel || '';
    }
    this.setAddressValidationModalInputError('');
    this.setAddressValidationModalSecondaryInputError('');
  }
  openAddressValidationModal() {
    var errorCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (!this.addressValidationModalComponent) return;
    var config = this.getAddressValidationModalConfig(errorCode);
    this.addressValidationIssue = errorCode;
    this.addressValidationModalState = config.state;
    this.addressValidationInputValue = String(config.value || '').trim();
    this.renderAddressValidationModal(config);
    if (!this.addressValidationModalComponent.classList.contains('modal--open')) {
      if (typeof this.addressValidationModalComponent.openModal === 'function') {
        this.addressValidationModalComponent.openModal(this.addressInput || this);
      }
    }
    if (config.requiresInput && this.addressValidationModalInput) {
      window.requestAnimationFrame(() => {
        this.addressValidationModalInput.focus();
        if (this.addressValidationModalInput.value) {
          this.addressValidationModalInput.select();
        }
      });
    }
  }
  openSuggestedAddressChoiceModal() {
    var suggestedAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.addressValidationModalState = ADDRESS_VALIDATION_MODAL_STATE_SUGGESTED;
    this.addressValidationSuggestedAddressCandidate = _objectSpread({}, suggestedAddress);
    this.addressValidationInputValue = '';
    this.renderAddressValidationModal({
      state: ADDRESS_VALIDATION_MODAL_STATE_SUGGESTED,
      requiresInput: false,
      showSuggestedCard: true,
      title: translate('Use validated address?', 'cartDeliveryOptions.address_validation.modal.suggested_title'),
      body: translate('Validation returned a suggested address. Continue to use it.', 'cartDeliveryOptions.address_validation.modal.suggested_body'),
      inputLabel: '',
      inputPlaceholder: '',
      submitLabel: translate('Continue', 'cartDeliveryOptions.address_validation.modal.continue'),
      inputMode: 'text',
      pattern: '',
      value: '',
      suggestedAddressLabel: this.getAddressChoiceLabel(suggestedAddress)
    });
    if (!this.addressValidationModalComponent.classList.contains('modal--open')) {
      if (typeof this.addressValidationModalComponent.openModal === 'function') {
        this.addressValidationModalComponent.openModal(this.addressInput || this);
      }
    }
  }
  finalizeValidatedAddressSelection(address) {
    var nextAddress = address && typeof address === 'object' ? address : null;
    if (!nextAddress) return;
    this.setSelectedAddress(nextAddress);
    this.closeAddressValidationModal();
    var deliveryAddress = this.toDeliveryAddressInput(nextAddress);
    if (deliveryAddress.address1 && deliveryAddress.city) {
      this.pendingDeliveryAddress = deliveryAddress;
      this.associatePendingAddress();
    }
  }
  validateAddressValidationModalInput() {
    var _this$addressValidati2;
    var rawValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var primaryValue = String(rawValue || '').trim();
    var secondaryValue = String(((_this$addressValidati2 = this.addressValidationModalInputSecondary) === null || _this$addressValidati2 === void 0 ? void 0 : _this$addressValidati2.value) || '').trim();
    var errors = {
      primary: '',
      secondary: ''
    };
    if (this.addressValidationModalState === ADDRESS_VALIDATION_MODAL_STATE_HOUSE_NUMBER && this.addressValidationIssue === ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_AND_ZIP_MISSING) {
      if (!primaryValue) {
        errors.primary = translate('Street number is required.', 'cartDeliveryOptions.address_validation.modal.house_number_required');
      }
      if (!secondaryValue) {
        errors.secondary = translate('ZIP code is required.', 'cartDeliveryOptions.address_validation.modal.zip_required');
      } else if (!ZIP_CODE_PATTERN.test(secondaryValue)) {
        errors.secondary = translate('Enter a valid ZIP code (example: 98101 or 98101-1234).', 'cartDeliveryOptions.address_validation.modal.zip_format');
      }
      return errors;
    }
    if (this.addressValidationModalState === ADDRESS_VALIDATION_MODAL_STATE_HOUSE_NUMBER) {
      if (!primaryValue) {
        errors.primary = translate('Street number is required.', 'cartDeliveryOptions.address_validation.modal.house_number_required');
      }
      return errors;
    }
    if (this.addressValidationModalState === ADDRESS_VALIDATION_MODAL_STATE_UNIT) {
      if (!primaryValue) {
        errors.primary = translate('Apartment or suite is required.', 'cartDeliveryOptions.address_validation.modal.unit_required');
      }
      return errors;
    }
    if (this.addressValidationModalState === ADDRESS_VALIDATION_MODAL_STATE_ZIP) {
      if (!primaryValue) {
        errors.primary = translate('ZIP code is required.', 'cartDeliveryOptions.address_validation.modal.zip_required');
      } else if (!ZIP_CODE_PATTERN.test(primaryValue)) {
        errors.primary = translate('Enter a valid ZIP code (example: 98101 or 98101-1234).', 'cartDeliveryOptions.address_validation.modal.zip_format');
      }
      return errors;
    }
    return errors;
  }
  onAddressValidationModalInputKeydown(event) {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    this.onAddressValidationModalSubmit();
  }
  onAddressValidationModalSubmitClick(event) {
    event.preventDefault();
    this.onAddressValidationModalSubmit();
  }
  onAddressValidationModalSubmit() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var _this2$addressValidat, _this2$addressValidat2, _this2$addressValidat5;
      if (_this2.addressValidationModalState === ADDRESS_VALIDATION_MODAL_STATE_INFO) {
        _this2.closeAddressValidationModal();
        return;
      }
      if (_this2.addressValidationModalState === ADDRESS_VALIDATION_MODAL_STATE_SUGGESTED) {
        _this2.finalizeValidatedAddressSelection(_this2.addressValidationSuggestedAddressCandidate);
        return;
      }
      if (!_this2.selectedAddress) {
        _this2.closeAddressValidationModal();
        return;
      }
      var inputValue = String(((_this2$addressValidat = _this2.addressValidationModalInput) === null || _this2$addressValidat === void 0 ? void 0 : _this2$addressValidat.value) || '').trim();
      var secondaryInputValue = String(((_this2$addressValidat2 = _this2.addressValidationModalInputSecondary) === null || _this2$addressValidat2 === void 0 ? void 0 : _this2$addressValidat2.value) || '').trim();
      var validationErrors = _this2.validateAddressValidationModalInput(inputValue);
      if (validationErrors.primary || validationErrors.secondary) {
        _this2.setAddressValidationModalInputError(validationErrors.primary || '');
        _this2.setAddressValidationModalSecondaryInputError(validationErrors.secondary || '');
        if (validationErrors.primary) {
          var _this2$addressValidat3;
          (_this2$addressValidat3 = _this2.addressValidationModalInput) === null || _this2$addressValidat3 === void 0 || _this2$addressValidat3.focus();
        } else if (validationErrors.secondary) {
          var _this2$addressValidat4;
          (_this2$addressValidat4 = _this2.addressValidationModalInputSecondary) === null || _this2$addressValidat4 === void 0 || _this2$addressValidat4.focus();
        }
        return;
      }
      _this2.setAddressValidationModalInputError('');
      _this2.setAddressValidationModalSecondaryInputError('');
      _this2.addressValidationInputValue = inputValue;
      _this2.setAddressValidationFeedback('');
      var candidateAddress = _objectSpread({}, _this2.selectedAddress);
      if (_this2.addressValidationModalState === ADDRESS_VALIDATION_MODAL_STATE_HOUSE_NUMBER) {
        var existingAddress1 = String(candidateAddress.address1 || '').trim();
        var routeFallback = existingAddress1.replace(/^\d+[a-z0-9-]*\s*/i, '').trim() || existingAddress1;
        candidateAddress.address1 = [inputValue, routeFallback].filter(Boolean).join(' ').trim();
        if (_this2.addressValidationIssue === ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_AND_ZIP_MISSING) {
          candidateAddress.zip = secondaryInputValue;
        }
      } else if (_this2.addressValidationModalState === ADDRESS_VALIDATION_MODAL_STATE_UNIT) {
        candidateAddress.address2 = inputValue;
      } else if (_this2.addressValidationModalState === ADDRESS_VALIDATION_MODAL_STATE_ZIP) {
        candidateAddress.zip = inputValue;
      }
      var validationRequestId = _this2.addressValidationRequestId + 1;
      _this2.addressValidationRequestId = validationRequestId;
      var submitLabel = String(((_this2$addressValidat5 = _this2.addressValidationModalSubmit) === null || _this2$addressValidat5 === void 0 ? void 0 : _this2$addressValidat5.textContent) || '').trim();
      _this2.setAddressValidationModalSubmitting(true, submitLabel);
      try {
        var validationResult = yield _this2.triggerAddressValidation(candidateAddress, validationRequestId);
        if (!validationResult || validationResult.stale) return;
        if (validationResult.serviceError) {
          _this2.setAddressValidationModalInputError(translate('Unable to validate this address right now. Please try again.', 'cartDeliveryOptions.address_validation.modal.service_unavailable'));
          return;
        }
        if (!validationResult.validationPassed) {
          _this2.setAddressValidationModalInputError(validationResult.errorMessage || translate('Address could not be validated. Please review and try again.', 'cartDeliveryOptions.address_validation.modal.validation_failed'));
          return;
        }
        if (validationResult.showingSuggestedChoice) return;
        _this2.finalizeValidatedAddressSelection(candidateAddress);
      } finally {
        _this2.setAddressValidationModalSubmitting(false, submitLabel);
      }
    })();
  }
  onAddressValidationModalCancel(event) {
    var _this$lastAssociatedA, _this$lastAssociatedA2;
    event === null || event === void 0 || event.preventDefault();
    this.closeAddressValidationModal();
    if ((_this$lastAssociatedA = this.lastAssociatedAddress) !== null && _this$lastAssociatedA !== void 0 && _this$lastAssociatedA.address1 && (_this$lastAssociatedA2 = this.lastAssociatedAddress) !== null && _this$lastAssociatedA2 !== void 0 && _this$lastAssociatedA2.city) {
      this.setSelectedAddress(this.lastAssociatedAddress);
      this.setAddressValidationFeedback('');
      this.setMessage('');
    }
  }
  setDeliveryOptionsDisabled(isDisabled) {
    this.optionsContainer.querySelectorAll("input[type=\"radio\"][name=\"".concat(this.deliveryOptionInputName, "\"]")).forEach(radioInput => {
      radioInput.disabled = isDisabled;
    });
  }
  setControlsDisabled(isDisabled) {
    this.setDeliveryOptionsDisabled(isDisabled);
    this.optionsContainer.querySelectorAll('input[data-standard-preference-handle], select[data-standard-preference-handle], select[data-ship-week-handle]').forEach(selectInput => {
      selectInput.disabled = isDisabled;
    });
  }
  showError(message) {
    this.setMessage(message);
    this.optionsContainer.innerHTML = '';
  }
  readMutationIssues(payload, mutationName) {
    var userErrors = Array.isArray(payload === null || payload === void 0 ? void 0 : payload.userErrors) ? payload.userErrors : [];
    var warnings = Array.isArray(payload === null || payload === void 0 ? void 0 : payload.warnings) ? payload.warnings : [];
    if (warnings.length > 0) {
      console.warn("cartForm: ".concat(mutationName, " warnings:"), warnings);
    }
    return {
      userErrors,
      warnings
    };
  }
  extractCartPayload(payload) {
    if (!payload || typeof payload !== 'object') return null;
    var nestedCart = payload.cart;
    if (nestedCart && typeof nestedCart === 'object') return nestedCart;
    return payload;
  }
  readDateOptionsInput(value) {
    if (!value) return null;
    if (typeof value === 'object' && !Array.isArray(value)) {
      return value;
    }
    if (typeof value !== 'string') return null;
    try {
      var parsedValue = JSON.parse(value);
      if (parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue)) {
        return parsedValue;
      }
    } catch (_error) {
      return null;
    }
    return null;
  }
  resolveDateOptions(data) {
    var _this$latestCartPaylo, _this$latestCartPaylo2, _this$latestCartPaylo3, _this$latestCartPaylo4;
    var cartPayload = this.extractCartPayload((data === null || data === void 0 ? void 0 : data.cart) || data || null);
    var payloadDateOptions = this.readDateOptionsInput((cartPayload === null || cartPayload === void 0 ? void 0 : cartPayload.dateOptions) || (cartPayload === null || cartPayload === void 0 ? void 0 : cartPayload.date_options) || (cartPayload === null || cartPayload === void 0 ? void 0 : cartPayload.shippingDateOptions) || (cartPayload === null || cartPayload === void 0 ? void 0 : cartPayload.shipping_date_options));
    if (payloadDateOptions) return payloadDateOptions;
    var latestCartDateOptions = this.readDateOptionsInput(((_this$latestCartPaylo = this.latestCartPayload) === null || _this$latestCartPaylo === void 0 ? void 0 : _this$latestCartPaylo.dateOptions) || ((_this$latestCartPaylo2 = this.latestCartPayload) === null || _this$latestCartPaylo2 === void 0 ? void 0 : _this$latestCartPaylo2.date_options) || ((_this$latestCartPaylo3 = this.latestCartPayload) === null || _this$latestCartPaylo3 === void 0 ? void 0 : _this$latestCartPaylo3.shippingDateOptions) || ((_this$latestCartPaylo4 = this.latestCartPayload) === null || _this$latestCartPaylo4 === void 0 ? void 0 : _this$latestCartPaylo4.shipping_date_options));
    if (latestCartDateOptions) return latestCartDateOptions;

    // Keep last endpoint-derived metadata when GraphQL refresh payloads omit date options.
    return this.dateOptions || this.initialDateOptions || null;
  }
  getCurrentCartData() {
    var _this$iamForm4;
    var formCart = this.extractCartPayload(((_this$iamForm4 = this.iamForm) === null || _this$iamForm4 === void 0 ? void 0 : _this$iamForm4.cart) || null);
    var latestCart = this.extractCartPayload(this.latestCartPayload || null);

    // Prefer whichever cart payload actually has line items/SKUs.
    if (this.getCartLineItems(formCart).length > 0) return formCart;
    if (this.getCartLineItems(latestCart).length > 0) return latestCart;
    return formCart || latestCart;
  }
  getCartLineItems(cartData) {
    var _cartData$lineItems, _cartData$line_items, _cartData$items;
    if (!cartData || typeof cartData !== 'object') return [];
    var candidates = [cartData.lineItems, cartData.line_items, cartData.items];
    var firstLineItems = candidates.find(candidate => Array.isArray(candidate));
    if (firstLineItems) return firstLineItems;
    var connectionCandidates = [(_cartData$lineItems = cartData.lineItems) === null || _cartData$lineItems === void 0 ? void 0 : _cartData$lineItems.edges, (_cartData$line_items = cartData.line_items) === null || _cartData$line_items === void 0 ? void 0 : _cartData$line_items.edges, (_cartData$items = cartData.items) === null || _cartData$items === void 0 ? void 0 : _cartData$items.edges];
    var firstConnection = connectionCandidates.find(candidate => Array.isArray(candidate));
    if (firstConnection) {
      return firstConnection.map(edge => (edge === null || edge === void 0 ? void 0 : edge.node) || null).filter(Boolean);
    }
    return [];
  }
  extractSkuFromLineItem(lineItem) {
    var _sourceLineItem$varia, _sourceLineItem$itemD, _sourceLineItem$itemD2, _sourceLineItem$merch, _sourceLineItem$varia2, _sourceLineItem$merch2, _sourceLineItem$produ, _sourceLineItem$produ2;
    if (!lineItem || typeof lineItem !== 'object') return '';
    var sourceLineItem = lineItem.node && typeof lineItem.node === 'object' ? lineItem.node : lineItem;
    var skuCandidates = [(_sourceLineItem$varia = sourceLineItem.variant) === null || _sourceLineItem$varia === void 0 ? void 0 : _sourceLineItem$varia.sku, sourceLineItem.sku, sourceLineItem.variant_sku, sourceLineItem.variantSku, (_sourceLineItem$itemD = sourceLineItem.itemData) === null || _sourceLineItem$itemD === void 0 || (_sourceLineItem$itemD = _sourceLineItem$itemD.variant) === null || _sourceLineItem$itemD === void 0 ? void 0 : _sourceLineItem$itemD.sku, (_sourceLineItem$itemD2 = sourceLineItem.itemData) === null || _sourceLineItem$itemD2 === void 0 ? void 0 : _sourceLineItem$itemD2.sku, (_sourceLineItem$merch = sourceLineItem.merchandise) === null || _sourceLineItem$merch === void 0 ? void 0 : _sourceLineItem$merch.sku, (_sourceLineItem$varia2 = sourceLineItem.variant) === null || _sourceLineItem$varia2 === void 0 || (_sourceLineItem$varia2 = _sourceLineItem$varia2.node) === null || _sourceLineItem$varia2 === void 0 ? void 0 : _sourceLineItem$varia2.sku, (_sourceLineItem$merch2 = sourceLineItem.merchandise) === null || _sourceLineItem$merch2 === void 0 || (_sourceLineItem$merch2 = _sourceLineItem$merch2.productVariant) === null || _sourceLineItem$merch2 === void 0 ? void 0 : _sourceLineItem$merch2.sku, (_sourceLineItem$produ = sourceLineItem.productData) === null || _sourceLineItem$produ === void 0 || (_sourceLineItem$produ = _sourceLineItem$produ.variant) === null || _sourceLineItem$produ === void 0 || (_sourceLineItem$produ = _sourceLineItem$produ.base) === null || _sourceLineItem$produ === void 0 ? void 0 : _sourceLineItem$produ.sku, (_sourceLineItem$produ2 = sourceLineItem.product_data) === null || _sourceLineItem$produ2 === void 0 || (_sourceLineItem$produ2 = _sourceLineItem$produ2.variant) === null || _sourceLineItem$produ2 === void 0 || (_sourceLineItem$produ2 = _sourceLineItem$produ2.base) === null || _sourceLineItem$produ2 === void 0 ? void 0 : _sourceLineItem$produ2.sku];
    var sku = skuCandidates.find(candidate => typeof candidate === 'string' && candidate.trim().length > 0);
    if (sku) return sku.trim();
    var skuFromDom = this.readSkuFromDomCartItemData(sourceLineItem);
    return skuFromDom || '';
  }
  getLineItemVariantIdCandidates(lineItem) {
    var _sourceLineItem$varia3, _sourceLineItem$varia4, _sourceLineItem$merch3, _sourceLineItem$produ3, _sourceLineItem$produ4;
    if (!lineItem || typeof lineItem !== 'object') return [];
    var sourceLineItem = lineItem.node && typeof lineItem.node === 'object' ? lineItem.node : lineItem;
    var rawCandidates = [sourceLineItem.variant_id, sourceLineItem.variantId, (_sourceLineItem$varia3 = sourceLineItem.variant) === null || _sourceLineItem$varia3 === void 0 ? void 0 : _sourceLineItem$varia3.id, (_sourceLineItem$varia4 = sourceLineItem.variant) === null || _sourceLineItem$varia4 === void 0 || (_sourceLineItem$varia4 = _sourceLineItem$varia4.node) === null || _sourceLineItem$varia4 === void 0 ? void 0 : _sourceLineItem$varia4.id, (_sourceLineItem$merch3 = sourceLineItem.merchandise) === null || _sourceLineItem$merch3 === void 0 ? void 0 : _sourceLineItem$merch3.id, (_sourceLineItem$produ3 = sourceLineItem.productData) === null || _sourceLineItem$produ3 === void 0 || (_sourceLineItem$produ3 = _sourceLineItem$produ3.variant) === null || _sourceLineItem$produ3 === void 0 || (_sourceLineItem$produ3 = _sourceLineItem$produ3.base) === null || _sourceLineItem$produ3 === void 0 ? void 0 : _sourceLineItem$produ3.id, (_sourceLineItem$produ4 = sourceLineItem.product_data) === null || _sourceLineItem$produ4 === void 0 || (_sourceLineItem$produ4 = _sourceLineItem$produ4.variant) === null || _sourceLineItem$produ4 === void 0 || (_sourceLineItem$produ4 = _sourceLineItem$produ4.base) === null || _sourceLineItem$produ4 === void 0 ? void 0 : _sourceLineItem$produ4.id].filter(candidate => candidate != null && String(candidate).trim().length > 0).map(candidate => String(candidate).trim());
    var normalizedCandidates = rawCandidates.flatMap(candidate => {
      var gidMatch = candidate.match(/(\d+)(?:\?.*)?$/);
      var idFromGid = gidMatch ? gidMatch[1] : '';
      return [candidate, idFromGid].filter(Boolean);
    });
    return Array.from(new Set(normalizedCandidates));
  }
  readSkuFromDomCartItemData(lineItem) {
    var variantIdCandidates = this.getLineItemVariantIdCandidates(lineItem);
    if (variantIdCandidates.length === 0) return '';
    var cartScope = this.closest('iam-cart-form') || document;
    var cartItemElements = Array.from(cartScope.querySelectorAll('iam-cart-item[data-item-data][data-product-data]'));
    if (cartItemElements.length === 0) return '';
    for (var cartItemElement of cartItemElements) {
      var _itemData, _itemData2, _productData, _itemData3, _productData2, _productData3;
      var itemData = null;
      var productData = null;
      try {
        itemData = JSON.parse(cartItemElement.dataset.itemData || '{}');
        productData = JSON.parse(cartItemElement.dataset.productData || '{}');
      } catch (_error) {
        continue;
      }
      var itemVariantIds = this.getLineItemVariantIdCandidates({
        variant_id: (_itemData = itemData) === null || _itemData === void 0 ? void 0 : _itemData.variant_id,
        variantId: (_itemData2 = itemData) === null || _itemData2 === void 0 ? void 0 : _itemData2.variantId,
        variant: {
          id: (_productData = productData) === null || _productData === void 0 || (_productData = _productData.variant) === null || _productData === void 0 || (_productData = _productData.base) === null || _productData === void 0 ? void 0 : _productData.id
        }
      });
      var hasVariantMatch = itemVariantIds.some(variantId => variantIdCandidates.includes(variantId));
      if (!hasVariantMatch) continue;
      var sku = [(_itemData3 = itemData) === null || _itemData3 === void 0 ? void 0 : _itemData3.sku, (_productData2 = productData) === null || _productData2 === void 0 || (_productData2 = _productData2.variant) === null || _productData2 === void 0 || (_productData2 = _productData2.base) === null || _productData2 === void 0 ? void 0 : _productData2.sku, (_productData3 = productData) === null || _productData3 === void 0 || (_productData3 = _productData3.variant) === null || _productData3 === void 0 ? void 0 : _productData3.sku].find(candidate => typeof candidate === 'string' && candidate.trim().length > 0);
      if (sku) return sku.trim();
    }
    return '';
  }
  buildLineItemsPayload(cartData) {
    var lineItems = this.getCartLineItems(cartData);
    return lineItems.map(lineItem => this.extractSkuFromLineItem(lineItem)).filter(Boolean).map(sku => ({
      sku
    }));
  }
  extractFulfillStartFromRecord(record) {
    if (!record || typeof record !== 'object') return '';
    var directCandidates = [record.fulfill_start, record.fulfillStart, record.fulfillment_start, record.fulfillmentStart];
    var directValue = directCandidates.find(candidate => typeof candidate === 'string' && candidate.trim().length > 0);
    if (directValue) return directValue.trim();
    var recordProperties = record.properties;
    if (recordProperties && typeof recordProperties === 'object' && !Array.isArray(recordProperties)) {
      var propertyEntries = Object.entries(recordProperties);
      var foundProperty = propertyEntries.find(_ref3 => {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        return /fulfill(?:ment)?_?start/i.test(String(key || '')) && typeof value === 'string' && value.trim().length > 0;
      });
      if (foundProperty) return foundProperty[1].trim();
    }
    return '';
  }
  findEarliestDateString() {
    var dateCandidates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (!Array.isArray(dateCandidates) || dateCandidates.length === 0) return '';
    var earliestDate = null;
    var earliestSource = '';
    dateCandidates.forEach(dateCandidate => {
      var normalizedCandidate = String(dateCandidate || '').trim();
      if (!normalizedCandidate) return;
      var parsedDate = new Date(normalizedCandidate);
      if (Number.isNaN(parsedDate.getTime())) return;
      if (!earliestDate || parsedDate.getTime() < earliestDate.getTime()) {
        earliestDate = parsedDate;
        earliestSource = normalizedCandidate;
      }
    });
    return earliestSource;
  }
  buildNextOrderEndpoint() {
    if (!this.customerEmail || !this.shippingMetadataEndpoint) return '';
    try {
      var endpointUrl = new URL('/api/customers/next-order', this.shippingMetadataEndpoint);
      endpointUrl.searchParams.set('email', this.customerEmail);
      return endpointUrl.toString();
    } catch (error) {
      console.warn('cartForm: Unable to build next order endpoint URL.', error);
      return '';
    }
  }
  readNextOrderScheduledAt() {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      if (!_this3.customerEmail) return null;
      if (_this3.nextOrderScheduledAt !== undefined) return _this3.nextOrderScheduledAt;
      if (_this3.nextOrderScheduledAtRequest) return _this3.nextOrderScheduledAtRequest;
      var endpointUrl = _this3.buildNextOrderEndpoint();
      if (!endpointUrl) {
        _this3.nextOrderScheduledAt = null;
        return null;
      }
      _this3.nextOrderScheduledAtRequest = window.fetch(endpointUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(/*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(function* (response) {
          var _payload;
          var payload = null;
          try {
            payload = yield response.json();
          } catch (_error) {
            payload = null;
          }
          if (!response.ok) {
            console.warn('cartForm: Unable to fetch next order date.', payload || response.statusText);
            _this3.nextOrderScheduledAt = null;
            return null;
          }
          var scheduledAt = String(((_payload = payload) === null || _payload === void 0 || (_payload = _payload.next_charge) === null || _payload === void 0 ? void 0 : _payload.scheduled_at) || '').trim();
          _this3.nextOrderScheduledAt = scheduledAt || null;
          return _this3.nextOrderScheduledAt;
        });
        return function (_x) {
          return _ref5.apply(this, arguments);
        };
      }()).catch(error => {
        console.warn('cartForm: Error fetching next order date.', error);
        _this3.nextOrderScheduledAt = null;
        return null;
      }).finally(() => {
        _this3.nextOrderScheduledAtRequest = null;
      });
      return _this3.nextOrderScheduledAtRequest;
    })();
  }
  toWeekNumberString(rawDate) {
    var parsedDate = new Date(rawDate);
    if (Number.isNaN(parsedDate.getTime())) return null;
    var utcDate = new Date(Date.UTC(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate()));
    var dayNumber = utcDate.getUTCDay() || 7;
    utcDate.setUTCDate(utcDate.getUTCDate() + 4 - dayNumber);
    var yearStart = new Date(Date.UTC(utcDate.getUTCFullYear(), 0, 1));
    var weekNumber = Math.ceil(((utcDate - yearStart) / 86400000 + 1) / 7);
    return String(weekNumber);
  }
  resolveBundledShipWeekFromCartData(cartData) {
    var _cartData$subscriptio, _cartData$subscriptio2;
    if (!cartData || typeof cartData !== 'object') return null;
    var explicitCandidate = [cartData.bundledShipWeek, cartData.bundled_ship_week, (_cartData$subscriptio = cartData.subscription) === null || _cartData$subscriptio === void 0 ? void 0 : _cartData$subscriptio.bundledShipWeek, (_cartData$subscriptio2 = cartData.subscription) === null || _cartData$subscriptio2 === void 0 ? void 0 : _cartData$subscriptio2.bundled_ship_week].find(candidate => candidate != null && String(candidate).trim() !== '');
    if (explicitCandidate != null) {
      return String(explicitCandidate).trim();
    }
    var dateCandidates = [this.extractFulfillStartFromRecord(cartData)];
    this.getCartLineItems(cartData).forEach(lineItem => {
      var fulfillStart = this.extractFulfillStartFromRecord(lineItem);
      if (fulfillStart) dateCandidates.push(fulfillStart);
    });
    var earliestFulfillStart = this.findEarliestDateString(dateCandidates);
    if (!earliestFulfillStart) return null;
    return this.toWeekNumberString(earliestFulfillStart);
  }
  resolveBundledShipWeek(cartData) {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      var nextOrderScheduledAt = yield _this4.readNextOrderScheduledAt();
      if (nextOrderScheduledAt) {
        return _this4.toWeekNumberString(nextOrderScheduledAt);
      }
      return _this4.resolveBundledShipWeekFromCartData(cartData);
    })();
  }
  buildShippingMetadataRequestPayload() {
    var _this5 = this;
    return _asyncToGenerator(function* () {
      var _this5$selectedAddres;
      var zip = String(((_this5$selectedAddres = _this5.selectedAddress) === null || _this5$selectedAddres === void 0 ? void 0 : _this5$selectedAddres.zip) || '').trim();
      if (!zip) return null;
      var cartData = _this5.getCurrentCartData();
      var nextOrderScheduledAt = yield _this5.readNextOrderScheduledAt();
      return {
        zip,
        bundledShipWeek: yield _this5.resolveBundledShipWeek(cartData),
        bundledChargeDate: nextOrderScheduledAt || undefined,
        line_items: _this5.buildLineItemsPayload(cartData)
      };
    })();
  }
  resolveDateOptionsFromEndpointPayload(payload) {
    var directCandidate = this.readDateOptionsInput(payload);
    if (isDateOptionsShapeValid(directCandidate)) return directCandidate;
    var nestedCandidate = this.readDateOptionsInput(payload === null || payload === void 0 ? void 0 : payload.data);
    if (isDateOptionsShapeValid(nestedCandidate)) return nestedCandidate;
    var shippingCandidate = this.readDateOptionsInput(payload === null || payload === void 0 ? void 0 : payload.shipping);
    if (isDateOptionsShapeValid(shippingCandidate)) return shippingCandidate;
    return null;
  }
  syncSelectedHandleFromMergedModel() {
    var _this$mergedShippingM, _this$mergedShippingM2, _this$mergedShippingM3;
    var pendingHandle = String(this.pendingSelectedHandle || '').trim();
    var hasPendingHandle = pendingHandle && ((_this$mergedShippingM = this.mergedShippingModel) === null || _this$mergedShippingM === void 0 || (_this$mergedShippingM = _this$mergedShippingM.entries) === null || _this$mergedShippingM === void 0 ? void 0 : _this$mergedShippingM.some(entry => (entry === null || entry === void 0 ? void 0 : entry.handle) && entry.handle === pendingHandle));
    if (hasPendingHandle) {
      this.selectedHandle = pendingHandle;
      return;
    }
    var hasSelectedHandle = (_this$mergedShippingM2 = this.mergedShippingModel) === null || _this$mergedShippingM2 === void 0 || (_this$mergedShippingM2 = _this$mergedShippingM2.entries) === null || _this$mergedShippingM2 === void 0 ? void 0 : _this$mergedShippingM2.some(entry => (entry === null || entry === void 0 ? void 0 : entry.handle) && entry.handle === this.selectedHandle);
    if (!hasSelectedHandle && (_this$mergedShippingM3 = this.mergedShippingModel) !== null && _this$mergedShippingM3 !== void 0 && _this$mergedShippingM3.defaultHandle) {
      this.selectedHandle = this.mergedShippingModel.defaultHandle;
    }
  }
  findMergedEntryByHandle() {
    var _this$mergedShippingM4;
    var handle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return null;
    var entries = Array.isArray((_this$mergedShippingM4 = this.mergedShippingModel) === null || _this$mergedShippingM4 === void 0 ? void 0 : _this$mergedShippingM4.entries) ? this.mergedShippingModel.entries : [];
    return entries.find(entry => String((entry === null || entry === void 0 ? void 0 : entry.handle) || '').trim() === normalizedHandle) || null;
  }
  findMergedEntryByType() {
    var _this$mergedShippingM5;
    var targetType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var entries = Array.isArray((_this$mergedShippingM5 = this.mergedShippingModel) === null || _this$mergedShippingM5 === void 0 ? void 0 : _this$mergedShippingM5.entries) ? this.mergedShippingModel.entries : [];
    return findShippingEntryByType(entries, targetType);
  }
  getSelectedStandardSubOption(mergedEntry) {
    if (!mergedEntry || mergedEntry.type !== SHIPPING_TYPE_STANDARD) return null;
    if (!Array.isArray(mergedEntry.standardSubOptions) || mergedEntry.standardSubOptions.length === 0) {
      return null;
    }
    var optionHandle = String(mergedEntry.handle || '').trim();
    var selectedValue = String(this.selectedShipWeekPreferenceByHandle[optionHandle] || '').trim();
    if (selectedValue) {
      return mergedEntry.standardSubOptions.find(subOption => String((subOption === null || subOption === void 0 ? void 0 : subOption.value) || '').trim() === selectedValue) || null;
    }
    return mergedEntry.standardSubOptions[0] || null;
  }
  ensureStandardPreferenceDefault() {
    var _mergedEntry$standard;
    var optionHandle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var normalizedHandle = String(optionHandle || '').trim();
    if (!normalizedHandle) return;
    if (String(this.selectedShipWeekPreferenceByHandle[normalizedHandle] || '').trim()) return;
    var mergedEntry = this.findMergedEntryByHandle(normalizedHandle);
    if (!mergedEntry || mergedEntry.type !== SHIPPING_TYPE_STANDARD) return;
    if (!Array.isArray(mergedEntry.standardSubOptions) || mergedEntry.standardSubOptions.length === 0) return;
    var defaultValue = String(((_mergedEntry$standard = mergedEntry.standardSubOptions[0]) === null || _mergedEntry$standard === void 0 ? void 0 : _mergedEntry$standard.value) || '').trim();
    if (!defaultValue) return;
    this.selectedShipWeekPreferenceByHandle[normalizedHandle] = defaultValue;
  }
  buildSelectedOptionForHandle() {
    var handle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle || !this.deliveryGroupId) return null;
    var mergedEntry = this.findMergedEntryByHandle(normalizedHandle);
    if (!mergedEntry) return null;
    var standardEntry = (mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.type) === SHIPPING_TYPE_BUNDLED && mergedEntry !== null && mergedEntry !== void 0 && mergedEntry.isSynthetic ? this.findMergedEntryByType(SHIPPING_TYPE_STANDARD) : null;
    var selectedDeliveryOptionHandle = String((standardEntry === null || standardEntry === void 0 ? void 0 : standardEntry.handle) || normalizedHandle).trim();
    var selectedStandardSubOption = this.getSelectedStandardSubOption(mergedEntry);
    var selectedShipWeek = String(this.selectedShipWeekPreferenceByHandle[normalizedHandle] || (selectedStandardSubOption === null || selectedStandardSubOption === void 0 ? void 0 : selectedStandardSubOption.shipWeekPreference) || (mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.shipWeekPreference) || '').trim();
    var selectedEstimatedDeliveryDateDisplay = normalizeEstimatedDeliveryDisplay((selectedStandardSubOption === null || selectedStandardSubOption === void 0 ? void 0 : selectedStandardSubOption.estimatedDeliveryDateDisplay) || (mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.estimatedDeliveryDateDisplay) || (mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.dateLabel) || '');
    var fallbackDateMetadata = this.resolveDateMetadataForOptionType(mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.type, selectedShipWeek);
    var resolvedShipWeek = selectedShipWeek || (fallbackDateMetadata === null || fallbackDateMetadata === void 0 ? void 0 : fallbackDateMetadata.shipWeekPreference) || '';
    var resolvedEstimatedDeliveryDateDisplay = selectedEstimatedDeliveryDateDisplay || (fallbackDateMetadata === null || fallbackDateMetadata === void 0 ? void 0 : fallbackDateMetadata.estimatedDeliveryDateDisplay) || '';
    return _objectSpread(_objectSpread({}, mergedEntry), {}, {
      // Keep a user-facing shipping line label for checkout attributes.
      title: String((mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.displayTitle) || (mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.title) || '').trim(),
      selectedDeliveryOptionInput: {
        deliveryGroupId: this.deliveryGroupId,
        deliveryOptionHandle: selectedDeliveryOptionHandle
      },
      shipWeekPreference: String((mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.shipWeekPreference) || (selectedStandardSubOption === null || selectedStandardSubOption === void 0 ? void 0 : selectedStandardSubOption.shipWeekPreference) || (fallbackDateMetadata === null || fallbackDateMetadata === void 0 ? void 0 : fallbackDateMetadata.shipWeekPreference) || '').trim(),
      estimatedDeliveryDateDisplay: normalizeEstimatedDeliveryDisplay((mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.estimatedDeliveryDateDisplay) || (fallbackDateMetadata === null || fallbackDateMetadata === void 0 ? void 0 : fallbackDateMetadata.estimatedDeliveryDateDisplay) || (mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.dateLabel) || ''),
      selectedShipWeek: String(resolvedShipWeek || '').trim(),
      selectedEstimatedDeliveryDateDisplay: normalizeEstimatedDeliveryDisplay(resolvedEstimatedDeliveryDateDisplay)
    });
  }
  resolveDateMetadataForOptionType() {
    var optionType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var selectedShipWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var normalizedType = String(optionType || '').trim();
    var normalizedSelectedShipWeek = String(selectedShipWeek || '').trim();
    if (normalizedType === SHIPPING_TYPE_STANDARD) {
      var _this$dateOptions;
      var standardOptions = Array.isArray((_this$dateOptions = this.dateOptions) === null || _this$dateOptions === void 0 ? void 0 : _this$dateOptions.standard) ? this.dateOptions.standard : [];
      var selectedStandardOption = standardOptions.find(standardOption => String((standardOption === null || standardOption === void 0 ? void 0 : standardOption.shipWeekPreference) || '').trim() === normalizedSelectedShipWeek) || standardOptions[0] || null;
      return {
        shipWeekPreference: String((selectedStandardOption === null || selectedStandardOption === void 0 ? void 0 : selectedStandardOption.shipWeekPreference) || normalizedSelectedShipWeek || '').trim(),
        estimatedDeliveryDateDisplay: readEstimatedDeliveryDisplay(selectedStandardOption || {})
      };
    }
    if (normalizedType === SHIPPING_TYPE_BUNDLED) {
      var _this$dateOptions2;
      var bundledOption = (_this$dateOptions2 = this.dateOptions) !== null && _this$dateOptions2 !== void 0 && _this$dateOptions2.bundled && typeof this.dateOptions.bundled === 'object' ? this.dateOptions.bundled : null;
      return {
        shipWeekPreference: String((bundledOption === null || bundledOption === void 0 ? void 0 : bundledOption.shipWeekPreference) || normalizedSelectedShipWeek || '').trim(),
        estimatedDeliveryDateDisplay: readEstimatedDeliveryDisplay(bundledOption || {})
      };
    }
    if (normalizedType === SHIPPING_TYPE_EXPEDITED) {
      var _this$dateOptions3;
      var expeditedOption = (_this$dateOptions3 = this.dateOptions) !== null && _this$dateOptions3 !== void 0 && _this$dateOptions3.expedited && typeof this.dateOptions.expedited === 'object' ? this.dateOptions.expedited : null;
      return {
        shipWeekPreference: String(normalizedSelectedShipWeek || '').trim(),
        estimatedDeliveryDateDisplay: readEstimatedDeliveryDisplay(expeditedOption || {})
      };
    }
    return {
      shipWeekPreference: String(normalizedSelectedShipWeek || '').trim(),
      estimatedDeliveryDateDisplay: ''
    };
  }
  normalizeAttributePairs(attributesSource) {
    if (Array.isArray(attributesSource)) {
      return attributesSource.map(attribute => {
        var _attribute$value;
        var key = String((attribute === null || attribute === void 0 ? void 0 : attribute.key) || '').trim();
        var value = String((_attribute$value = attribute === null || attribute === void 0 ? void 0 : attribute.value) !== null && _attribute$value !== void 0 ? _attribute$value : '').trim();
        if (!key) return null;
        return {
          key,
          value
        };
      }).filter(Boolean);
    }
    if (attributesSource && typeof attributesSource === 'object') {
      return Object.entries(attributesSource).map(_ref6 => {
        var _ref7 = _slicedToArray(_ref6, 2),
          key = _ref7[0],
          value = _ref7[1];
        var normalizedKey = String(key || '').trim();
        var normalizedValue = String(value !== null && value !== void 0 ? value : '').trim();
        if (!normalizedKey) return null;
        return {
          key: normalizedKey,
          value: normalizedValue
        };
      }).filter(Boolean);
    }
    return [];
  }
  getCurrentCartAttributes() {
    var _this$iamForm5;
    var sources = [this.extractCartPayload(((_this$iamForm5 = this.iamForm) === null || _this$iamForm5 === void 0 ? void 0 : _this$iamForm5.cart) || null), this.extractCartPayload(this.latestCartPayload || null)];
    var seenKeys = new Set();
    var mergedAttributes = [];
    sources.forEach(source => {
      var nextAttributes = this.normalizeAttributePairs(source === null || source === void 0 ? void 0 : source.attributes);
      nextAttributes.forEach(attribute => {
        if (!(attribute !== null && attribute !== void 0 && attribute.key) || seenKeys.has(attribute.key)) return;
        seenKeys.add(attribute.key);
        mergedAttributes.push(attribute);
      });
    });
    return mergedAttributes;
  }
  getCurrentCartAttributeValue() {
    var attributeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var normalizedKey = String(attributeKey || '').trim();
    if (!normalizedKey) return '';
    var matchingAttribute = this.getCurrentCartAttributes().find(attribute => String((attribute === null || attribute === void 0 ? void 0 : attribute.key) || '').trim() === normalizedKey);
    return String((matchingAttribute === null || matchingAttribute === void 0 ? void 0 : matchingAttribute.value) || '').trim();
  }
  readSelectedShippingLineAttribute() {
    return (this.getCurrentCartAttributeValue('selected_shipping_line') || this.getCurrentCartAttributeValue('selectedShippingLine') || '').trim();
  }
  isBundledShippingLineValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var normalizedValue = normalizeMatchText(value);
    return normalizedValue === 'ship with next order' || normalizedValue === 'shippingnextorder';
  }
  syncSelectedHandleFromCheckoutAttributes() {
    var _this$mergedShippingM6;
    var selectedShippingLine = this.readSelectedShippingLineAttribute();
    if (!selectedShippingLine) return;
    var currentlySelectedEntry = this.findMergedEntryByHandle(this.selectedHandle);
    if ((currentlySelectedEntry === null || currentlySelectedEntry === void 0 ? void 0 : currentlySelectedEntry.type) !== SHIPPING_TYPE_STANDARD) return;
    var bundledEntry = Array.isArray((_this$mergedShippingM6 = this.mergedShippingModel) === null || _this$mergedShippingM6 === void 0 ? void 0 : _this$mergedShippingM6.entries) ? this.mergedShippingModel.entries.find(entry => (entry === null || entry === void 0 ? void 0 : entry.type) === SHIPPING_TYPE_BUNDLED) : null;
    if (bundledEntry && this.isBundledShippingLineValue(selectedShippingLine)) {
      this.selectedHandle = String(bundledEntry.handle || '').trim();
    }
  }
  syncStandardPreferenceFromCheckoutAttributes() {
    var selectedEntry = this.findMergedEntryByHandle(this.selectedHandle);
    if (!selectedEntry || selectedEntry.type !== SHIPPING_TYPE_STANDARD) return;
    var standardHandle = String(selectedEntry.handle || '').trim();
    if (!standardHandle) return;
    if (String(this.selectedShipWeekPreferenceByHandle[standardHandle] || '').trim()) return;
    var shipWeekPreference = (this.getCurrentCartAttributeValue('ship_week_preference') || this.getCurrentCartAttributeValue('shipWeekPreference') || '').trim();
    if (!shipWeekPreference) return;
    var hasMatchingSubOption = Array.isArray(selectedEntry.standardSubOptions) && selectedEntry.standardSubOptions.some(subOption => String((subOption === null || subOption === void 0 ? void 0 : subOption.value) || '').trim() === shipWeekPreference);
    if (!hasMatchingSubOption) return;
    this.selectedShipWeekPreferenceByHandle[standardHandle] = shipWeekPreference;
  }
  buildCheckoutCustomAttributes(selectedOption) {
    var selectedShippingLine = String((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.title) || '').trim();
    var selectedShipWeek = String((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectedShipWeek) || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.shipWeekPreference) || '').trim();
    var selectedEstimatedDeliveryDateDisplay = normalizeEstimatedDeliveryDisplay((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectedEstimatedDeliveryDateDisplay) || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.estimatedDeliveryDateDisplay) || '');
    var attributeKeys = ['selected_shipping_line', 'ship_week_preference', 'ship_week_display'];
    var baseAttributes = [{
      key: 'selected_shipping_line',
      value: selectedShippingLine
    }, {
      key: 'ship_week_preference',
      value: selectedShipWeek
    }, {
      key: 'ship_week_display',
      value: selectedEstimatedDeliveryDateDisplay
    }];
    var existingAttributes = this.getCurrentCartAttributes();
    var mergedAttributes = [...baseAttributes];
    existingAttributes.forEach(attribute => {
      var _attribute$value2;
      if (!(attribute !== null && attribute !== void 0 && attribute.key)) return;
      if (attributeKeys.includes(attribute.key)) return;
      if (String((_attribute$value2 = attribute === null || attribute === void 0 ? void 0 : attribute.value) !== null && _attribute$value2 !== void 0 ? _attribute$value2 : '').trim().length === 0) return;
      mergedAttributes.push(attribute);
    });

    // Always send the 3 shipping attribute keys; keep existing attributes only when non-empty.
    return mergedAttributes.filter(attribute => attribute === null || attribute === void 0 ? void 0 : attribute.key);
  }
  applyCartAttributesFromGraphqlCart(cartPayload) {
    var _this$iamForm6;
    if (!cartPayload || typeof cartPayload !== 'object') return;
    if (!Object.prototype.hasOwnProperty.call(cartPayload, 'attributes')) return;
    var normalizedAttributes = this.normalizeAttributePairs(cartPayload.attributes);
    var attributeMap = normalizedAttributes.reduce((attributesObject, attribute) => {
      attributesObject[attribute.key] = attribute.value;
      return attributesObject;
    }, {});
    if ((_this$iamForm6 = this.iamForm) !== null && _this$iamForm6 !== void 0 && _this$iamForm6.cart && typeof this.iamForm.cart === 'object') {
      this.iamForm.cart.attributes = _objectSpread({}, attributeMap);
    }
    if (this.latestCartPayload && typeof this.latestCartPayload === 'object') {
      this.latestCartPayload.attributes = _objectSpread({}, attributeMap);
    }
  }
  updateCheckoutCustomAttributesForSelectedOption(selectedOption) {
    var _this6 = this;
    return _asyncToGenerator(function* () {
      if (!selectedOption || !_this6.cartId) return;
      var mergedAttributes = _this6.buildCheckoutCustomAttributes(selectedOption);
      var _yield$storefrontApi$ = yield storefrontApi.request(UPDATE_CHECKOUT_CUSTOM_ATTRIBUTES_MUTATION, {
          cartId: _this6.cartId,
          attributes: mergedAttributes
        }),
        data = _yield$storefrontApi$.data;
      var mutationPayload = (data === null || data === void 0 ? void 0 : data.cartAttributesUpdate) || {};
      var _this6$readMutationIs = _this6.readMutationIssues(mutationPayload, 'cartAttributesUpdate'),
        userErrors = _this6$readMutationIs.userErrors;
      if (userErrors.length > 0) {
        throw new Error(userErrors.map(userError => userError.message).join(' '));
      }
      _this6.applyCartAttributesFromGraphqlCart((mutationPayload === null || mutationPayload === void 0 ? void 0 : mutationPayload.cart) || null);
    })();
  }
  buildDiscountCodesForSelectedOption(selectedOption) {
    var codes = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.type) === SHIPPING_TYPE_BUNDLED ? ['Ship with Next Order'] : [];

    // This list replaces the cart's codes; keep one auto-applied this
    // session (subscription-cards A/B test) — see helpers/auto-discount.
    return keepAutoDiscountCodes(codes);
  }
  updateDiscountCodesForSelectedOption(selectedOption) {
    var _this7 = this;
    return _asyncToGenerator(function* () {
      if (!selectedOption || !_this7.cartId) return;
      var _yield$storefrontApi$2 = yield storefrontApi.request(UPDATE_DISCOUNT_CODES_MUTATION, {
          cartId: _this7.cartId,
          discountCodes: _this7.buildDiscountCodesForSelectedOption(selectedOption)
        }),
        data = _yield$storefrontApi$2.data;
      var mutationPayload = (data === null || data === void 0 ? void 0 : data.cartDiscountCodesUpdate) || {};
      var _this7$readMutationIs = _this7.readMutationIssues(mutationPayload, 'cartDiscountCodesUpdate'),
        userErrors = _this7$readMutationIs.userErrors;
      if (userErrors.length > 0) {
        throw new Error(userErrors.map(userError => userError.message).join(' '));
      }
    })();
  }
  refreshDateOptionsFromEndpoint() {
    var _this8 = this;
    return _asyncToGenerator(function* () {
      if (!Array.isArray(_this8.deliveryOptions) || _this8.deliveryOptions.length === 0) return false;
      var requestPayload = yield _this8.buildShippingMetadataRequestPayload();
      if (!requestPayload || !_this8.shippingMetadataEndpoint) return false;
      _this8.shippingMetadataRequestId += 1;
      var requestId = _this8.shippingMetadataRequestId;
      if (_this8.shippingMetadataAbortController) {
        _this8.shippingMetadataAbortController.abort();
      }
      var abortController = new AbortController();
      _this8.shippingMetadataAbortController = abortController;
      try {
        var response = yield window.fetch(_this8.shippingMetadataEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestPayload),
          signal: abortController.signal
        });
        if (!response.ok) {
          throw new Error("Shipping metadata request failed with status ".concat(response.status));
        }
        var endpointPayload = yield response.json();
        if (requestId !== _this8.shippingMetadataRequestId) return false;
        var endpointDateOptions = _this8.resolveDateOptionsFromEndpointPayload(endpointPayload);
        if (!endpointDateOptions) return false;
        _this8.dateOptions = endpointDateOptions;
        _this8.mergedShippingModel = mergeShippingOptions(_this8.deliveryOptions, _this8.dateOptions);
        _this8.syncSelectedHandleFromCheckoutAttributes();
        _this8.syncSelectedHandleFromMergedModel();
        _this8.syncStandardPreferenceFromCheckoutAttributes();
        return true;
      } catch (error) {
        if ((error === null || error === void 0 ? void 0 : error.name) === 'AbortError') return false;

        // Fallback rule: keep current Shopify-backed UI when endpoint data is unavailable.
        console.warn('cartForm: Unable to refresh date options from shipping endpoint.', error);
        return false;
      } finally {
        if (_this8.shippingMetadataAbortController === abortController) {
          _this8.shippingMetadataAbortController = null;
        }
      }
    })();
  }
  applyDeliveryOptionsFromData(data) {
    var _this9 = this;
    return _asyncToGenerator(function* () {
      var _data$cart, _firstDeliveryGroup$s;
      var firstDeliveryGroup = (data === null || data === void 0 || (_data$cart = data.cart) === null || _data$cart === void 0 || (_data$cart = _data$cart.deliveryGroups) === null || _data$cart === void 0 || (_data$cart = _data$cart.nodes) === null || _data$cart === void 0 ? void 0 : _data$cart[0]) || null;
      _this9.applyCartAttributesFromGraphqlCart((data === null || data === void 0 ? void 0 : data.cart) || null);
      _this9.deliveryGroupId = (firstDeliveryGroup === null || firstDeliveryGroup === void 0 ? void 0 : firstDeliveryGroup.id) || null;
      _this9.selectedHandle = (firstDeliveryGroup === null || firstDeliveryGroup === void 0 || (_firstDeliveryGroup$s = firstDeliveryGroup.selectedDeliveryOption) === null || _firstDeliveryGroup$s === void 0 ? void 0 : _firstDeliveryGroup$s.handle) || '';
      _this9.deliveryOptions = Array.isArray(firstDeliveryGroup === null || firstDeliveryGroup === void 0 ? void 0 : firstDeliveryGroup.deliveryOptions) ? firstDeliveryGroup.deliveryOptions : [];
      var selectedCartAddress = _this9.normalizeDeliveryAddress(firstDeliveryGroup === null || firstDeliveryGroup === void 0 ? void 0 : firstDeliveryGroup.deliveryAddress);
      if (selectedCartAddress !== null && selectedCartAddress !== void 0 && selectedCartAddress.address1 && selectedCartAddress !== null && selectedCartAddress !== void 0 && selectedCartAddress.city) {
        _this9.lastAssociatedAddress = _objectSpread({}, selectedCartAddress);
        _this9.setSelectedAddress(selectedCartAddress);
      } else if (!_this9.isAssociatingAddress) {
        _this9.lastAssociatedAddress = null;
        _this9.selectedAddress = null;
        if (_this9.addressInput) _this9.addressInput.value = '';
      }
      _this9.dateOptions = _this9.resolveDateOptions(data);
      _this9.mergedShippingModel = mergeShippingOptions(_this9.deliveryOptions, _this9.dateOptions);
      if (_this9.deliveryOptions.length === 0) {
        var _this9$selectedAddres, _this9$selectedAddres2;
        var hasCheckedAddress = Boolean(((_this9$selectedAddres = _this9.selectedAddress) === null || _this9$selectedAddres === void 0 ? void 0 : _this9$selectedAddres.address1) && ((_this9$selectedAddres2 = _this9.selectedAddress) === null || _this9$selectedAddres2 === void 0 ? void 0 : _this9$selectedAddres2.city));
        _this9.setMessage(hasCheckedAddress ? translate('No delivery options are currently available for this cart.', 'cartDeliveryOptions.empty') : translate('Enter your ZIP to see your delivery date.', 'cartDeliveryOptions.empty_without_address'));
        return;
      }
      yield _this9.refreshDateOptionsFromEndpoint();
      _this9.syncSelectedHandleFromCheckoutAttributes();
      _this9.syncSelectedHandleFromMergedModel();
      _this9.syncStandardPreferenceFromCheckoutAttributes();
      _this9.renderOptions();
      if (_this9.pendingSelectedHandle && _this9.pendingSelectedHandle === _this9.selectedHandle) {
        _this9.pendingSelectedHandle = '';
      }
      _this9.setMessage('');
    })();
  }
  loadDeliveryOptions() {
    var _arguments = arguments,
      _this0 = this;
    return _asyncToGenerator(function* () {
      var _ref8 = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {},
        _ref8$showLoading = _ref8.showLoading,
        showLoading = _ref8$showLoading === void 0 ? true : _ref8$showLoading;
      var cartToken = yield _this0.ensureCartToken();
      if (!cartToken) {
        _this0.showError(translate('Unable to load delivery options: cart token was not found.', 'cartDeliveryOptions.error_missing_token'));
        return;
      }
      _this0.cartToken = cartToken;
      _this0.cartId = _this0.buildCartId(_this0.cartToken);
      if (!_this0.hasSecretKey(_this0.cartToken)) {
        console.warn('cartForm: Cart token is missing ?key=. Delivery options may be unavailable.', {
          cartToken: _this0.cartToken
        });
      }
      if (showLoading) {
        _this0.setLoading(true);
        _this0.setControlsDisabled(true);
        _this0.setMessage(translate('Loading delivery options...', 'cartDeliveryOptions.loading'));
      }
      try {
        var _yield$storefrontApi$3 = yield storefrontApi.request(CART_DELIVERY_OPTIONS_QUERY, {
            id: _this0.cartId
          }),
          data = _yield$storefrontApi$3.data;
        yield _this0.applyDeliveryOptionsFromData(data);
      } catch (error) {
        console.error('cartForm: Error loading delivery options:', error);
        _this0.showError(translate('Unable to load delivery options. Please try again.', 'cartDeliveryOptions.error_load'));
      } finally {
        if (showLoading) {
          _this0.setControlsDisabled(false);
          _this0.setLoading(false);
        }
      }
    })();
  }
  getAddressValidationEndpoint() {
    try {
      return new URL('/api/maps/address-validation', this.shippingMetadataEndpoint || SHIPPING_METADATA_ENDPOINT_DEFAULT).toString();
    } catch (_error) {
      return ADDRESS_VALIDATION_ENDPOINT_DEFAULT;
    }
  }
  buildAddressValidationPayload(address) {
    if (!address || typeof address !== 'object') return null;
    var addressLines = [String(address.address1 || '').trim(), String(address.address2 || '').trim()].filter(Boolean);
    var locality = String(address.city || '').trim();
    var administrativeArea = String(address.provinceCode || address.province || '').trim();
    var postalCode = String(address.zip || '').trim();
    var hasMinimumData = addressLines.length > 0 || Boolean(locality) || Boolean(administrativeArea) || Boolean(postalCode);
    if (!hasMinimumData) return null;
    return {
      address: {
        addressLines,
        locality,
        administrativeArea,
        postalCode,
        regionCode: String(address.country || 'US').trim() || 'US'
      }
    };
  }
  mapAddressValidationIssueToFrontendError() {
    var issue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var code = String((issue === null || issue === void 0 ? void 0 : issue.code) || '').trim();
    var component = String((issue === null || issue === void 0 ? void 0 : issue.component) || '').trim();
    var token = String((issue === null || issue === void 0 ? void 0 : issue.token) || '').trim();
    if (code === 'MISSING_COMPONENT' && isPostalCodeComponent(component)) {
      return ADDRESS_VALIDATION_ERROR_ZIP_NOT_FOUND;
    }
    if (code === 'MISSING_COMPONENT' && isStreetNumberComponent(component)) {
      return ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_MISSING;
    }
    if (code === 'MISSING_COMPONENT' && isUnitComponent(component)) {
      return ADDRESS_VALIDATION_ERROR_UNIT_MISSING;
    }
    if (code === 'UNCONFIRMED_COMPONENT' && isPostalCodeComponent(component)) {
      return ADDRESS_VALIDATION_ERROR_ZIP_INVALID;
    }
    if (code === 'UNCONFIRMED_COMPONENT' && isStreetNumberComponent(component)) {
      return ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_MISSING;
    }
    if (code === 'UNCONFIRMED_COMPONENT' && isUnitComponent(component)) {
      return ADDRESS_VALIDATION_ERROR_UNIT_MISSING;
    }
    if (code === 'UNRESOLVED_TOKEN' && isZipLikeToken(token)) {
      return ADDRESS_VALIDATION_ERROR_ZIP_INVALID;
    }
    if (code === 'USPS_DPV_MISSING_UNIT' || code === 'USPS_DPV_INVALID_UNIT') {
      return ADDRESS_VALIDATION_ERROR_UNIT_MISSING;
    }
    if (code === 'USPS_DPV_UNDELIVERABLE' || code === 'USPS_SECURITY_FLAG') {
      return ADDRESS_VALIDATION_ERROR_ADDRESS_NOT_FOUND;
    }
    return ADDRESS_VALIDATION_ERROR_ADDRESS_NOT_FOUND;
  }
  getAddressValidationErrorFromIssues() {
    var issues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (!Array.isArray(issues) || issues.length === 0) return '';
    var mappedErrors = issues.map(issue => this.mapAddressValidationIssueToFrontendError(issue));
    var hasHouseNumberIssue = mappedErrors.includes(ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_MISSING);
    var hasZipIssue = mappedErrors.includes(ADDRESS_VALIDATION_ERROR_ZIP_NOT_FOUND) || mappedErrors.includes(ADDRESS_VALIDATION_ERROR_ZIP_INVALID);
    if (hasHouseNumberIssue && hasZipIssue) {
      return ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_AND_ZIP_MISSING;
    }
    var priority = [ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_MISSING, ADDRESS_VALIDATION_ERROR_UNIT_MISSING, ADDRESS_VALIDATION_ERROR_ZIP_NOT_FOUND, ADDRESS_VALIDATION_ERROR_ZIP_INVALID, ADDRESS_VALIDATION_ERROR_ADDRESS_NOT_FOUND];
    return priority.find(errorCode => mappedErrors.includes(errorCode)) || '';
  }
  isNonBlockingAddressValidationIssue() {
    var issue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var code = String((issue === null || issue === void 0 ? void 0 : issue.code) || '').trim();
    var component = String((issue === null || issue === void 0 ? void 0 : issue.component) || '').trim();
    if (code === 'USPS_DPV_MISSING_UNIT' || code === 'USPS_DPV_INVALID_UNIT') {
      return true;
    }
    if ((code === 'MISSING_COMPONENT' || code === 'UNCONFIRMED_COMPONENT') && isUnitComponent(component)) {
      return true;
    }
    return false;
  }
  getBlockingAddressValidationIssues() {
    var issues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (!Array.isArray(issues) || issues.length === 0) return [];
    return issues.filter(issue => !this.isNonBlockingAddressValidationIssue(issue));
  }
  getAddressValidationFeedbackMessage() {
    var errorCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (errorCode === ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_AND_ZIP_MISSING) {
      return translate('Street number and ZIP code are required for this address.', 'cartDeliveryOptions.address_validation.house_number_and_zip_missing');
    }
    if (errorCode === ADDRESS_VALIDATION_ERROR_HOUSE_NUMBER_MISSING) {
      return translate('Street number is missing for this address.', 'cartDeliveryOptions.address_validation.house_number_missing');
    }
    if (errorCode === ADDRESS_VALIDATION_ERROR_ZIP_NOT_FOUND) {
      return translate('ZIP code is missing for this address.', 'cartDeliveryOptions.address_validation.zip_missing');
    }
    if (errorCode === ADDRESS_VALIDATION_ERROR_ZIP_INVALID) {
      return translate('ZIP code could not be validated. Correct it in the address validation prompt.', 'cartDeliveryOptions.address_validation.zip_invalid');
    }
    if (errorCode === ADDRESS_VALIDATION_ERROR_UNIT_MISSING) {
      return translate('Apartment or suite is required for this address. Add it in the address validation prompt.', 'cartDeliveryOptions.address_validation.unit_missing');
    }
    return translate('This address could not be validated for delivery. Please check the address details and try again.', 'cartDeliveryOptions.address_validation.address_not_found');
  }
  handleAddressValidationResponse(validationPayload) {
    var validatedAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var issues = Array.isArray(validationPayload === null || validationPayload === void 0 ? void 0 : validationPayload.issues) ? validationPayload.issues : [];
    var blockingIssues = this.getBlockingAddressValidationIssues(issues);
    var validationPassed = blockingIssues.length === 0;
    if (validationPassed) {
      this.setAddressValidationFeedback('');
      var currentAddress = validatedAddress || this.selectedAddress || {};
      var suggestedPostalAddress = (validationPayload === null || validationPayload === void 0 ? void 0 : validationPayload.suggestedPostalAddress) || null;
      if (suggestedPostalAddress && typeof suggestedPostalAddress === 'object') {
        var suggestedAddress = this.buildAddressFromSuggestedPostalAddress(currentAddress, suggestedPostalAddress, (validationPayload === null || validationPayload === void 0 ? void 0 : validationPayload.formattedAddress) || '');
        if (this.hasMeaningfulSuggestedAddressChange(currentAddress, suggestedAddress)) {
          this.openSuggestedAddressChoiceModal(suggestedAddress);
          return {
            validationPassed: true,
            errorCode: '',
            errorMessage: '',
            showingSuggestedChoice: true,
            suggestedAddress
          };
        }
      }
      this.closeAddressValidationModal();
      return {
        validationPassed: true,
        errorCode: '',
        errorMessage: '',
        showingSuggestedChoice: false,
        suggestedAddress: null
      };
    }
    var errorCode = this.getAddressValidationErrorFromIssues(blockingIssues) || ADDRESS_VALIDATION_ERROR_ADDRESS_NOT_FOUND;
    var feedbackMessage = this.getAddressValidationFeedbackMessage(errorCode);
    this.setAddressValidationFeedback(feedbackMessage);
    this.openAddressValidationModal(errorCode);
    return {
      validationPassed: false,
      errorCode,
      errorMessage: feedbackMessage,
      showingSuggestedChoice: false,
      suggestedAddress: null
    };
  }
  triggerAddressValidation(address) {
    var _arguments2 = arguments,
      _this1 = this;
    return _asyncToGenerator(function* () {
      var requestId = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : 0;
      var payload = _this1.buildAddressValidationPayload(address);
      if (!payload) {
        return {
          validationPassed: false,
          errorCode: ADDRESS_VALIDATION_ERROR_ADDRESS_NOT_FOUND,
          errorMessage: '',
          showingSuggestedChoice: false,
          suggestedAddress: null,
          payload: null,
          stale: false,
          serviceError: false
        };
      }
      try {
        var response = yield window.fetch(_this1.getAddressValidationEndpoint(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        var responsePayload = yield response.json().catch(() => null);
        if (requestId && requestId !== _this1.addressValidationRequestId) {
          return {
            stale: true,
            validationPassed: false,
            serviceError: false,
            errorCode: '',
            errorMessage: '',
            showingSuggestedChoice: false,
            suggestedAddress: null,
            payload: null
          };
        }
        if (!response.ok) {
          _this1.setAddressValidationFeedback(translate('Address validation service is currently unavailable. Please continue and verify your address details.', 'cartDeliveryOptions.address_validation.service_unavailable'));
          return {
            validationPassed: false,
            errorCode: ADDRESS_VALIDATION_ERROR_ADDRESS_NOT_FOUND,
            errorMessage: '',
            showingSuggestedChoice: false,
            suggestedAddress: null,
            payload: responsePayload || null,
            stale: false,
            serviceError: true
          };
        }
        var responseResult = _this1.handleAddressValidationResponse(responsePayload || {}, address);
        return {
          validationPassed: Boolean(responseResult === null || responseResult === void 0 ? void 0 : responseResult.validationPassed),
          errorCode: (responseResult === null || responseResult === void 0 ? void 0 : responseResult.errorCode) || '',
          errorMessage: (responseResult === null || responseResult === void 0 ? void 0 : responseResult.errorMessage) || '',
          showingSuggestedChoice: Boolean(responseResult === null || responseResult === void 0 ? void 0 : responseResult.showingSuggestedChoice),
          suggestedAddress: (responseResult === null || responseResult === void 0 ? void 0 : responseResult.suggestedAddress) || null,
          payload: responsePayload || null,
          stale: false,
          serviceError: false
        };
      } catch (error) {
        if (requestId && requestId !== _this1.addressValidationRequestId) {
          return {
            stale: true,
            validationPassed: false,
            serviceError: false,
            errorCode: '',
            errorMessage: '',
            showingSuggestedChoice: false,
            suggestedAddress: null,
            payload: null
          };
        }
        console.warn('cartForm: Non-blocking address validation request failed.', error);
        _this1.setAddressValidationFeedback(translate('Address validation service is currently unavailable. Please continue and verify your address details.', 'cartDeliveryOptions.address_validation.service_unavailable'));
        return {
          validationPassed: false,
          errorCode: ADDRESS_VALIDATION_ERROR_ADDRESS_NOT_FOUND,
          errorMessage: '',
          showingSuggestedChoice: false,
          suggestedAddress: null,
          payload: null,
          stale: false,
          serviceError: true
        };
      }
    })();
  }
  onAddressSelected(event) {
    var _this10 = this;
    return _asyncToGenerator(function* () {
      var _event$detail;
      var nextAddress = (event === null || event === void 0 || (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.address) || null;
      if (!nextAddress) return;
      _this10.closeAddressValidationModal();
      _this10.setSelectedAddress(nextAddress);
      _this10.setAddressValidationFeedback('');
      var deliveryAddress = _this10.toDeliveryAddressInput(_this10.selectedAddress);
      if (!deliveryAddress.address1 || !deliveryAddress.city) {
        _this10.setMessage(translate('Select an address with a street and city.', 'cartDeliveryOptions.select_address_required'));
        return;
      }
      var validationRequestId = _this10.addressValidationRequestId + 1;
      _this10.addressValidationRequestId = validationRequestId;
      var validationResult = yield _this10.triggerAddressValidation(_this10.selectedAddress, validationRequestId);
      if (!validationResult || validationResult.stale) return;
      if (validationResult.serviceError) {
        _this10.setMessage(translate('Unable to validate the selected address. Please try again.', 'cartDeliveryOptions.address_validation.service_unavailable'));
        return;
      }
      if (!validationResult.validationPassed) return;
      if (validationResult.showingSuggestedChoice) return;
      _this10.finalizeValidatedAddressSelection(_this10.selectedAddress);
    })();
  }
  setSelectedAddress(address) {
    if (!address || typeof address !== 'object') return;
    this.selectedAddress = {
      address1: String(address.address1 || '').trim(),
      address2: String(address.address2 || '').trim(),
      city: String(address.city || '').trim(),
      province: String(address.province || '').trim(),
      provinceCode: String(address.provinceCode || '').trim(),
      zip: String(address.zip || '').trim(),
      country: String(address.country || '').trim() || 'US',
      formattedAddress: String(address.formattedAddress || '').trim(),
      location: address.location || null
    };
    if (this.selectedAddress.city && this.selectedAddress.address1) {
      this.selectedAddress.country = 'US';
    }
    var inputLabel = this.getAddressDisplayValue(this.selectedAddress);
    if (this.addressInput && inputLabel) {
      this.addressInput.value = inputLabel;
    }
  }
  getAddressDisplayValue(address) {
    if (!address) return '';
    if (address.formattedAddress) return address.formattedAddress;
    return [address.address1, address.address2, [address.city, address.provinceCode || address.province].filter(Boolean).join(', '), address.zip].filter(Boolean).join(' ').trim();
  }
  normalizeDeliveryAddress(deliveryAddress) {
    if (!deliveryAddress || typeof deliveryAddress !== 'object') return null;
    return {
      address1: String(deliveryAddress.address1 || '').trim(),
      address2: String(deliveryAddress.address2 || '').trim(),
      city: String(deliveryAddress.city || '').trim(),
      province: String(deliveryAddress.province || '').trim(),
      provinceCode: String(deliveryAddress.provinceCode || '').trim(),
      zip: String(deliveryAddress.zip || '').trim(),
      country: String(deliveryAddress.country || deliveryAddress.countryCodeV2 || '').trim() || 'US',
      formattedAddress: '',
      location: null
    };
  }
  toDeliveryAddressInput(address) {
    var provinceCodeCandidate = String((address === null || address === void 0 ? void 0 : address.provinceCode) || (address === null || address === void 0 ? void 0 : address.province) || '').trim();
    var provinceCode = provinceCodeCandidate.length === 2 ? provinceCodeCandidate.toUpperCase() : '';
    var countryCode = String((address === null || address === void 0 ? void 0 : address.country) || 'US').trim().toUpperCase() || 'US';
    var deliveryAddress = {
      address1: String((address === null || address === void 0 ? void 0 : address.address1) || '').trim(),
      address2: String((address === null || address === void 0 ? void 0 : address.address2) || '').trim(),
      city: String((address === null || address === void 0 ? void 0 : address.city) || '').trim(),
      countryCode,
      zip: String((address === null || address === void 0 ? void 0 : address.zip) || '').trim()
    };
    if (provinceCode) {
      deliveryAddress.provinceCode = provinceCode;
    }
    return deliveryAddress;
  }
  associateAddressAndReloadOptions(deliveryAddress) {
    var _this11 = this;
    return _asyncToGenerator(function* () {
      var cartToken = yield _this11.ensureCartToken();
      if (!cartToken) {
        _this11.setMessage(translate('Unable to associate address: cart token was not found.', 'cartDeliveryOptions.error_missing_token_associate'));
        return;
      }
      _this11.cartToken = cartToken;
      _this11.cartId = _this11.buildCartId(_this11.cartToken);
      _this11.setLoading(true);
      _this11.setControlsDisabled(true);
      _this11.setMessage(translate('Associating selected address...', 'cartDeliveryOptions.loading_associate_address'));
      try {
        var _yield$storefrontApi$4 = yield storefrontApi.request(CART_DELIVERY_ADDRESSES_ADD_MUTATION, {
            cartId: _this11.cartId,
            addresses: [{
              selected: true,
              address: {
                deliveryAddress
              }
            }]
          }),
          data = _yield$storefrontApi$4.data;
        var mutationPayload = (data === null || data === void 0 ? void 0 : data.cartDeliveryAddressesAdd) || {};
        var _this11$readMutationI = _this11.readMutationIssues(mutationPayload, 'cartDeliveryAddressesAdd'),
          userErrors = _this11$readMutationI.userErrors;
        if (userErrors.length > 0) {
          throw new Error(userErrors.map(userError => userError.message).join(' '));
        }
        var updatedCart = mutationPayload.cart || null;
        if (updatedCart) {
          yield _this11.applyDeliveryOptionsFromData({
            cart: updatedCart
          });
        }
        yield _this11.loadDeliveryOptions({
          showLoading: false
        });
      } catch (error) {
        console.error('cartForm: Error associating selected address:', error);
        _this11.setMessage(translate('Unable to associate the selected address. Please try again.', 'cartDeliveryOptions.error_associate_address'));
      } finally {
        _this11.setControlsDisabled(false);
        _this11.setLoading(false);
      }
    })();
  }
  associatePendingAddress() {
    var _this12 = this;
    return _asyncToGenerator(function* () {
      if (_this12.isAssociatingAddress || !_this12.pendingDeliveryAddress) return;
      var deliveryAddress = _this12.pendingDeliveryAddress;
      _this12.pendingDeliveryAddress = null;
      _this12.isAssociatingAddress = true;
      try {
        yield _this12.associateAddressAndReloadOptions(deliveryAddress);
      } finally {
        _this12.isAssociatingAddress = false;
        if (_this12.pendingDeliveryAddress) {
          yield _this12.associatePendingAddress();
        }
      }
    })();
  }
  onDeliveryOptionChange(event) {
    var _this13 = this;
    return _asyncToGenerator(function* () {
      var selectedInput = event.target;
      if (selectedInput instanceof HTMLInputElement && selectedInput.type === 'radio' && selectedInput.dataset.standardPreferenceHandle) {
        if (!selectedInput.checked) return;
        var standardHandle = String(selectedInput.dataset.standardPreferenceHandle || '').trim();
        var selectedValue = String(selectedInput.dataset.standardPreferenceValue || selectedInput.value || '').trim();
        if (!standardHandle || !selectedValue) return;
        _this13.selectedShipWeekPreferenceByHandle[standardHandle] = selectedValue;

        // Keep the Standard parent selected when picking a child timing option.
        if (_this13.selectedHandle !== standardHandle) {
          var _previousHandle = _this13.selectedHandle;
          yield _this13.updateSelectedDeliveryOption(standardHandle, _previousHandle);
          return;
        }
        _this13.renderOptions();
        try {
          var selectedOption = _this13.buildSelectedOptionForHandle(standardHandle);
          if (selectedOption) {
            yield _this13.updateCheckoutCustomAttributesForSelectedOption(selectedOption);
          }
        } catch (attributesError) {
          console.warn('cartForm: Error updating checkout custom attributes after standard preference change:', attributesError);
        }
        return;
      }
      if ((selectedInput === null || selectedInput === void 0 ? void 0 : selectedInput.name) !== _this13.deliveryOptionInputName) return;
      if (!_this13.deliveryGroupId) return;
      var nextHandle = selectedInput.value;
      if (!nextHandle || nextHandle === _this13.selectedHandle) return;
      _this13.ensureStandardPreferenceDefault(nextHandle);
      var previousHandle = _this13.selectedHandle;
      yield _this13.updateSelectedDeliveryOption(nextHandle, previousHandle);
    })();
  }
  updateSelectedDeliveryOption(deliveryOptionHandle) {
    var _arguments3 = arguments,
      _this14 = this;
    return _asyncToGenerator(function* () {
      var previousHandle = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : '';
      var cartToken = yield _this14.ensureCartToken();
      if (!cartToken) {
        _this14.setMessage(translate('Unable to update delivery option: cart token was not found.', 'cartDeliveryOptions.error_missing_token_update'));
        _this14.selectedHandle = previousHandle;
        _this14.renderOptions();
        return;
      }
      _this14.cartToken = cartToken;
      _this14.cartId = _this14.buildCartId(_this14.cartToken);
      _this14.setLoading(true);
      _this14.setControlsDisabled(true);
      _this14.setMessage(translate('Updating delivery option...', 'cartDeliveryOptions.loading_update_selected_option'));
      _this14.pendingSelectedHandle = deliveryOptionHandle;
      _this14.selectedHandle = deliveryOptionHandle;
      _this14.renderOptions();
      var selectedOption = _this14.buildSelectedOptionForHandle(deliveryOptionHandle);
      if (selectedOption !== null && selectedOption !== void 0 && selectedOption.isSynthetic) {
        var _selectedDeliveryOptionInput = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectedDeliveryOptionInput) || {
          deliveryGroupId: _this14.deliveryGroupId,
          deliveryOptionHandle
        };
        try {
          var _yield$storefrontApi$5 = yield storefrontApi.request(CART_SELECTED_DELIVERY_OPTIONS_UPDATE_MUTATION, {
              cartId: _this14.cartId,
              selectedDeliveryOptions: [_selectedDeliveryOptionInput]
            }),
            data = _yield$storefrontApi$5.data;
          var mutationPayload = (data === null || data === void 0 ? void 0 : data.cartSelectedDeliveryOptionsUpdate) || {};
          var _this14$readMutationI = _this14.readMutationIssues(mutationPayload, 'cartSelectedDeliveryOptionsUpdate'),
            userErrors = _this14$readMutationI.userErrors;
          if (userErrors.length > 0) {
            throw new Error(userErrors.map(userError => userError.message).join(' '));
          }
          var updatedCart = mutationPayload.cart || null;
          if (updatedCart) {
            yield _this14.applyDeliveryOptionsFromData({
              cart: updatedCart
            });
          }
          yield _this14.updateDiscountCodesForSelectedOption(selectedOption);
          yield _this14.updateCheckoutCustomAttributesForSelectedOption(selectedOption);
          _this14.syncSelectedHandleFromCheckoutAttributes();
          _this14.renderOptions();
          var latestCart = yield cart.fetch();
          yield iamotaEventHandler.applyFilters('cart:modified:deliveryOption', latestCart);
          _this14.pendingSelectedHandle = '';
          _this14.setMessage('');
        } catch (attributesError) {
          console.warn('cartForm: Error updating synthetic delivery option state:', attributesError);
          _this14.pendingSelectedHandle = '';
          _this14.selectedHandle = previousHandle;
          _this14.renderOptions();
          _this14.setMessage(translate('Unable to update the delivery option. Please try again.', 'cartDeliveryOptions.error_update_selected_option'));
        } finally {
          _this14.setControlsDisabled(false);
          _this14.setLoading(false);
        }
        return;
      }
      var selectedDeliveryOptionInput = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectedDeliveryOptionInput) || {
        deliveryGroupId: _this14.deliveryGroupId,
        deliveryOptionHandle
      };
      try {
        var _yield$storefrontApi$6 = yield storefrontApi.request(CART_SELECTED_DELIVERY_OPTIONS_UPDATE_MUTATION, {
            cartId: _this14.cartId,
            selectedDeliveryOptions: [selectedDeliveryOptionInput]
          }),
          _data = _yield$storefrontApi$6.data;
        var _mutationPayload = (_data === null || _data === void 0 ? void 0 : _data.cartSelectedDeliveryOptionsUpdate) || {};
        var _this14$readMutationI2 = _this14.readMutationIssues(_mutationPayload, 'cartSelectedDeliveryOptionsUpdate'),
          _userErrors = _this14$readMutationI2.userErrors;
        if (_userErrors.length > 0) {
          throw new Error(_userErrors.map(userError => userError.message).join(' '));
        }
        var _updatedCart = _mutationPayload.cart || null;
        if (_updatedCart) {
          yield _this14.applyDeliveryOptionsFromData({
            cart: _updatedCart
          });
        } else {
          _this14.selectedHandle = deliveryOptionHandle;
          _this14.renderOptions();
          _this14.setMessage('');
        }
        try {
          var selectedOptionAfterUpdate = _this14.buildSelectedOptionForHandle(deliveryOptionHandle) || selectedOption;
          if (selectedOptionAfterUpdate) {
            yield _this14.updateDiscountCodesForSelectedOption(selectedOptionAfterUpdate);
            yield _this14.updateCheckoutCustomAttributesForSelectedOption(selectedOptionAfterUpdate);
            _this14.syncSelectedHandleFromCheckoutAttributes();
            _this14.renderOptions();
          }
        } catch (attributesError) {
          throw attributesError;
        }
        var _latestCart = yield cart.fetch();
        yield iamotaEventHandler.applyFilters('cart:modified:deliveryOption', _latestCart);
        _this14.pendingSelectedHandle = '';
      } catch (error) {
        console.error('cartForm: Error updating selected delivery option:', error);
        _this14.pendingSelectedHandle = '';
        _this14.selectedHandle = previousHandle;
        _this14.renderOptions();
        _this14.setMessage(translate('Unable to update the delivery option. Please try again.', 'cartDeliveryOptions.error_update_selected_option'));
      } finally {
        _this14.setControlsDisabled(false);
        _this14.setLoading(false);
      }
    })();
  }
  renderOptions() {
    var _this$mergedShippingM7;
    var mergedEntries = Array.isArray((_this$mergedShippingM7 = this.mergedShippingModel) === null || _this$mergedShippingM7 === void 0 ? void 0 : _this$mergedShippingM7.entries) ? this.mergedShippingModel.entries : [];
    if (mergedEntries.length === 0) {
      this.optionsContainer.innerHTML = '';
      return;
    }
    var optionsHtml = mergedEntries.map((mergedEntry, index) => {
      var optionHandle = (mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.handle) || '';
      var optionId = "".concat(this.deliveryOptionInputName, "-").concat(index);
      var isSelected = optionHandle && optionHandle === this.selectedHandle;
      var optionDateLabelHtml = this.renderOptionDateLabel(mergedEntry);
      var optionMetadataHtml = this.renderOptionMetadata(mergedEntry, optionId);
      return "<li class=\"cart-delivery-options__list-item\">\n                <label\n                    class=\"cart-delivery-options__item ".concat(isSelected ? 'is-selected' : '', "\"\n                    for=\"").concat(this.escapeHtml(optionId), "\"\n                >\n                    <input\n                        class=\"cart-delivery-options__radio\"\n                        type=\"radio\"\n                        id=\"").concat(this.escapeHtml(optionId), "\"\n                        name=\"").concat(this.escapeHtml(this.deliveryOptionInputName), "\"\n                        value=\"").concat(this.escapeHtml(optionHandle), "\"\n                        ").concat(isSelected ? 'checked' : '', "\n                    />\n                    <span class=\"cart-delivery-options__indicator\" aria-hidden=\"true\"></span>\n                    <span class=\"cart-delivery-options__content\">\n                        <span class=\"cart-delivery-options__header\">\n                            <span class=\"cart-delivery-options__label\">").concat(this.escapeHtml(this.getOptionTitle(mergedEntry)), "</span>\n                            ").concat(this.renderOptionPrice(mergedEntry), "\n                        </span>\n                        ").concat(optionDateLabelHtml, "\n                    </span>\n                </label>\n                ").concat(optionMetadataHtml, "\n            </li>");
    }).join('');
    this.optionsContainer.innerHTML = "<ul class=\"cart-delivery-options__list\">".concat(optionsHtml, "</ul>");
  }
  renderOptionDateLabel(mergedEntry) {
    if (!mergedEntry || typeof mergedEntry !== 'object') return '';
    var estimatedDeliveryLabel = String(mergedEntry.dateLabel || '').trim();
    if (!estimatedDeliveryLabel) return '';
    return "<p class=\"cart-delivery-options__item-meta-line\">".concat(this.escapeHtml(estimatedDeliveryLabel), "</p>");
  }
  renderOptionMetadata(mergedEntry, optionId) {
    if (!mergedEntry || typeof mergedEntry !== 'object') return '';
    var metadataLines = [];
    if (mergedEntry.type === SHIPPING_TYPE_STANDARD && Array.isArray(mergedEntry.standardSubOptions) && mergedEntry.standardSubOptions.length > 0) {
      metadataLines.push(this.renderStandardSubOptions(mergedEntry, optionId));
    }
    if (metadataLines.length === 0) return '';
    return "<div class=\"cart-delivery-options__meta\">".concat(metadataLines.join(''), "</div>");
  }
  renderStandardSubOptions(mergedEntry, optionId) {
    var _mergedEntry$standard2;
    var optionHandle = String((mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.handle) || '').trim();
    if (!optionHandle) return '';
    var isParentSelected = optionHandle === this.selectedHandle;
    var selectedValue = String(this.selectedShipWeekPreferenceByHandle[optionHandle] || '').trim();
    var fallbackValue = String(((_mergedEntry$standard2 = mergedEntry.standardSubOptions) === null || _mergedEntry$standard2 === void 0 || (_mergedEntry$standard2 = _mergedEntry$standard2[0]) === null || _mergedEntry$standard2 === void 0 ? void 0 : _mergedEntry$standard2.value) || '').trim();
    var currentValue = isParentSelected ? selectedValue || fallbackValue : '';
    var radioName = "".concat(optionId, "-standard-preference");
    var optionHtml = mergedEntry.standardSubOptions.map(subOption => {
      var value = String((subOption === null || subOption === void 0 ? void 0 : subOption.value) || '').trim();
      var label = String((subOption === null || subOption === void 0 ? void 0 : subOption.label) || '').trim();
      if (!value || !label) return '';
      var subOptionId = "".concat(optionId, "-standard-sub-option-").concat(this.escapeHtml(value));
      var isSelected = currentValue === value;
      return "<li class=\"cart-delivery-options__sub-list-item\">\n                <label\n                    class=\"cart-delivery-options__sub-item ".concat(isSelected ? 'is-selected' : '', "\"\n                    for=\"").concat(subOptionId, "\"\n                >\n                    <input\n                        class=\"cart-delivery-options__sub-radio\"\n                        type=\"radio\"\n                        id=\"").concat(subOptionId, "\"\n                        name=\"").concat(this.escapeHtml(radioName), "\"\n                        value=\"").concat(this.escapeHtml(value), "\"\n                        data-standard-preference-handle=\"").concat(this.escapeHtml(optionHandle), "\"\n                        data-standard-preference-value=\"").concat(this.escapeHtml(value), "\"\n                        ").concat(isSelected ? 'checked' : '', "\n                    />\n                    <span class=\"cart-delivery-options__sub-indicator\" aria-hidden=\"true\"></span>\n                    <span class=\"cart-delivery-options__sub-label\">").concat(this.escapeHtml(label), "</span>\n                </label>\n            </li>");
    }).join('');
    if (!optionHtml) return '';
    return "<div class=\"cart-delivery-options__ship-week\" role=\"group\">\n            <ul class=\"cart-delivery-options__sub-list\">".concat(optionHtml, "</ul>\n        </div>");
  }
  getOptionTitle(mergedEntry) {
    return (mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.displayTitle) || (mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.title) || '';
  }
  renderOptionPrice(mergedEntry) {
    var _mergedEntry$price, _mergedEntry$source, _mergedEntry$source2;
    var amount = (_mergedEntry$price = mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.price) !== null && _mergedEntry$price !== void 0 ? _mergedEntry$price : mergedEntry === null || mergedEntry === void 0 || (_mergedEntry$source = mergedEntry.source) === null || _mergedEntry$source === void 0 || (_mergedEntry$source = _mergedEntry$source.estimatedCost) === null || _mergedEntry$source === void 0 ? void 0 : _mergedEntry$source.amount;
    var currencyCode = (mergedEntry === null || mergedEntry === void 0 ? void 0 : mergedEntry.currencyCode) || (mergedEntry === null || mergedEntry === void 0 || (_mergedEntry$source2 = mergedEntry.source) === null || _mergedEntry$source2 === void 0 || (_mergedEntry$source2 = _mergedEntry$source2.estimatedCost) === null || _mergedEntry$source2 === void 0 ? void 0 : _mergedEntry$source2.currencyCode);
    var costLabel = this.formatMoney(amount, currencyCode);
    if (!costLabel) return '';
    return "<span class=\"cart-delivery-options__price\">".concat(this.escapeHtml(costLabel), "</span>");
  }
  formatMoney(amount, currencyCode) {
    if (amount == null) return '';
    var value = Number(amount);
    if (Number.isNaN(value)) return '';
    if (!currencyCode) return value.toString();
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currencyCode
      }).format(value);
    } catch (_error) {
      return "".concat(value, " ").concat(currencyCode);
    }
  }
  escapeHtml() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
}
customElements.define('iam-cart-delivery-options', iamCartDeliveryOptions);